import { Injectable } from '@angular/core';
import { BudgetDeterminationSystem, ProcurementProjectDTO, RequestMaterialDTO } from '../../api/plyca-dtos-v2';
import { FormConfig, FormConfigHelper } from '../../components/forms/form.objects';
import { formatDate } from '@angular/common';
import * as  moment from 'moment';

@Injectable()
export class ProcurementProjectAYMADValidations implements FormConfigHelper {
  private static isComplementarySystemBaseSD(model: any) {
    if (model.classification && model.classification.complementarySystem) {
      return model.classification.complementarySystem === 'CSDA<>SISTCOMPLEMENTARIO'
    }
    return false;
  }



  private static isComplementarySystemAM_SDA(model: any) {
    if (model.classification && model.classification.complementarySystem) {
      let isAM =
        model.classification.complementarySystem === 'AM<>SISTCOMPLEMENTARIO';
      let isSDA =
        model.classification.complementarySystem === 'SDA<>SISTCOMPLEMENTARIO';
      return isAM || isSDA;
    }
    return false;
  }


  private static isConcession(model: any) {
    if (model.parent != undefined && model.parent) {
      model = model.parent;
    }
    if (model && model.classification && model.classification.subTypeCode) {
      let isConcession =
        model.classification.subTypeCode === undefined
          ? false
          : model.classification.subTypeCode.identifier === '01<>MODALIDADEXPTE';
      return isConcession;
    }
    return false;
  }

  private static isAwardingVariousCriteria(model: any) {
    if (model.parent != undefined && model.parent) {
      model = model.parent;
    }
    if (model && model.classification && model.classification.awardMethod) {
      let isAwardingVariousCriteria =
        model.classification.awardMethod === undefined
          ? false
          : model.classification.awardMethod.identifier ===
          'P<>FORMASADJUDICACION';
      return isAwardingVariousCriteria;
    }
    return false;
  }
  private static isPrivate(model: any) {
    if (model.parent != undefined && model.parent) {
      model = model.parent;
    }
    if (model && model.classification && model.classification.typeCode) {
      let isPrivate =
        model.classification.typeCode === undefined
          ? false
          : model.classification.typeCode.identifier === '09<>TIPOEXPTE';
      return isPrivate;
    }
    return false;
  }

  // Modificado para que se consulte desde el Paso 1 y desde el Paso 2
  private static isConsultancy(model: any) {
    // Si existe el padre, la clasificación se obtiene del padre
    if (model.parent != undefined && model.parent) {
      model = model.parent;
    }
    if (model && model.classification && model.classification.typeCode) {
      let isConsultancy =
        model.classification.typeCode === undefined
          ? false
          : model.classification.typeCode.identifier === '03<>TIPOEXPTE';
      return isConsultancy;
    }
    return false;
  }




  private static isServiciesPublic(model: any) {
    if (model.classification && model.classification.typeCode) {
      let isServiciesPublic =
        model.classification.typeCode === undefined
          ? false
          : model.classification.typeCode.identifier === '06<>TIPOEXPTE';
      return isServiciesPublic;
    }
    return false;
  }
  public static isWorkConcession(model: any) {
    if (model.classification && model.classification.typeCode) {
      let isWorkConcession =
        model.classification.typeCode === undefined
          ? false
          : model.classification.typeCode.identifier === '10<>TIPOEXPTE';
      return isWorkConcession;
    }
    return false;
  }

  public static isServicesConcession(model: any) {
    if (model.classification && model.classification.typeCode) {
      let isServicesConcession =
        model.classification.typeCode === undefined
          ? false
          : model.classification.typeCode.identifier === '11<>TIPOEXPTE';
      return isServicesConcession;
    }
    return false;
  }
  private static isGoods(model: any) {
    if (model.parent != undefined && model.parent) {
      model = model.parent;
    }
    if (model.classification && model.classification.typeCode) {
      let isGoods =
        model.classification.typeCode === undefined
          ? false
          : model.classification.typeCode.identifier === '02<>TIPOEXPTE';
      return isGoods;
    }
    return false;
  }

  // Funcion invocada desde Paso 1, Paso 2
  private static isWorks(model: any) {
    if (model.parent != undefined && model.parent) {
      model = model.parent;
    }
    if (model.classification && model.classification.typeCode) {
      let isWorks =
        model.classification.typeCode === undefined
          ? false
          : model.classification.typeCode.identifier === '01<>TIPOEXPTE';
      return isWorks;
    }
    return false;
  }
  private static isServices(model: any) {
    if (model.parent != undefined && model.parent) {
      model = model.parent;
    }
    if (model.classification && model.classification.typeCode) {
      let isServices =
        model.classification.typeCode === undefined
          ? false
          : model.classification.typeCode.identifier === '04<>TIPOEXPTE';
      return isServices;
    }
    return false;
  }

  private static isPatrimonial(model: any) {
    if (model.classification && model.classification.typeCode) {
      let isServices =
        model.classification.typeCode === undefined
          ? false
          : model.classification.typeCode.identifier === '12<>TIPOEXPTE';
      return isServices;
    }
    return false;
  }
  private static amountEstimatedAmount(model: any) {
    if (model.budget) {
      let amountEstimatedAmount =
        model.budget.estimatedAmount === undefined
          ? 0
          : model.budget.estimatedAmount;
      return amountEstimatedAmount;
    }
    return 0;
  }


  // TIPOS DE PROCEDIMIENTO y MODOS DE PROCEDIMIENTO
  private static isDesignContest(model: any) {
    if (model.type) {
      let isDesignContest =
        model.type &&
        model.type.identifier != undefined &&
        model.type.identifier === 'CP<>PROCEDIMIENTOSCONTRA';
      return isDesignContest;
    }
    return false;
  }

  // Modo Dialogo Competitivo
  private static isCompetitiveDialogue(model: any) {
    return ProcurementProjectAYMADValidations.isTypeMode(model, 'DC');
  }

  // Abierto Simplificado Abreviado
  private static isOpenSimplifiedAbreviated(model: any) {
    if (model.parent != undefined && model.parent) {
      model = model.parent;
    }
    if (model.type) {
      let openSimplifiedAbreviated =
        model.type &&
        model.type.identifier != undefined &&
        model.type.identifier === 'ASA<>PROCEDIMIENTOSCONTRA';
      return openSimplifiedAbreviated;
    }
    return false;
  }

  // Licitacion con Negociacion
  private static isTenderWithNegotiation(model: any) {
    if (model.parent != undefined && model.parent) {
      model = model.parent;
    }
    if (model.type) {
      let isTenderWithNegotiation =
        model.type &&
        model.type.identifier != undefined &&
        model.type.identifier === 'LN<>PROCEDIMIENTOSCONTRA';
      return isTenderWithNegotiation;
    }
    return false;
  }


  private static isAssociationForInnovation(model: any) {
    if (model.type) {
      let isAssociationForInnovation =
        model.type &&
        model.type.identifier != undefined &&
        model.type.identifier === 'API<>PROCEDIMIENTOSCONTRA';
      return isAssociationForInnovation;
    }
    return false;
  }

  // Negociado sin Publicidad
  private static isNegotiatedWithoutPublicity(model: any) {
    if (model.parent != undefined && model.parent) {
      model = model.parent;
    }
    if (model.type) {
      let isNegotiatedWithoutPublicity =
        model.type &&
        model.type.identifier != undefined &&
        model.type.identifier === 'NSP<>PROCEDIMIENTOSCONTRA';
      return isNegotiatedWithoutPublicity;
    }
    return false;
  }

  private static participantsLimit(model: any) {
    if (model.type) {
      let participantsLimit =
        model.characteristicsContractObject.participantsLimit === undefined
          ? false
          : model.characteristicsContractObject.participantsLimit;
      return participantsLimit;
    }
    return false;
  }

  // MODOS DE PROCEDIMIENTO
  // esAdjAcuerdoMarco = modoProc.equals("AAM")]
  private static isBasedFrameworkAgreement(model: any) {
    return ProcurementProjectAYMADValidations.isTypeMode(model, 'AAM');
  }

  // esMenor = modoProc.equals("M")
  public static isMinorContract(model: any) {
    return ProcurementProjectAYMADValidations.isTypeMode(model, 'M');
  }
  // si es restringuido: [esRestringido = modoProc.equals("R") || (esConcursoProyectos && hayLimiteNumParticipantes)]
  private static isRestrictedContract(model: any) {
    return ProcurementProjectAYMADValidations.isTypeMode(model, 'R');
  }

  // si es abierto: [esAbierto = modoProc.equals("A") || (esConcursoProyectos && !hayLimiteNumParticipantes)]
  private static isOpenContract(model: any) {
    let isOpenContract = ProcurementProjectAYMADValidations.isTypeMode(model, 'A');
    return isOpenContract;
  }

  // Si es Negociado
  public static isNegotiated(model: any) {
    return ProcurementProjectAYMADValidations.isTypeMode(model, 'N');
  }

  constructor() { }

  /*

    TODO: BORRAR CUANDO TERMINAR EL DESARROLLO!!

    hayLimiteNumParticipantes => participantsLimit(model)
    esConcursoProyectos ==>  isDesignContest(model)
    esAbierto           ==>  isOpenContract(model)
    esMenor             ==>  isMinorContract(model)
    esRestringido       ==>  isRestrictedContract (model)
    esPNegociado        ==>  isNegotiated(model)
    esDCompetitivo      ==>  isCompetitiveDialogue(model)
    esAdjAcuerdoMarco   ==>  isBasedFrameworkAgreement(model)
    esAbiertoSimpli     ==>
    esAbiertoSimpliAbrev==> isOpenSimplifiedAbreviated
    esLicitacionNegociada ==> isTenderWithNegotiation(model)
    esNegociadoSinPubli ==> isNegotiatedWithoutPublicity(model)
    esAsociacionInnov   ==> isAssociationForInnovation
    esComprasCC ==> isCentralizedPurchases

    esObras              ==> isWorks(model)
    esSuministros        ==> isGoods(model)
    esServicios          ==> isServices (model)
    esConcesionServicios ==> isServicesConcession
    esConcesionObras     ==> isWorkConcession
    esServicioPublico    ==> isServiciesPublic
    esConsultoria        ==> isConsultancy
    esCPrivado           ==> isPrivate



    esConcesion          ==> isConcession
    esAcuerdoMarco       ==> isComplementarySystemAM_SDA
    esContratoBaseSD     ==> isComplementarySystemBaseSD

    importe estimado ==>  amountEstimatedAmount(model)

    esFadjPluralidadCriterios = isAwardingVariousCriteria(model)

 !esMenor && !esObras && !esCPrivado
   */





  public isvisibleComplementarySystem(model: any) {
    let isActiveComplementarySystem =
      (model.context &&
        model.context.configurations &&
        model.context.configurations.isActiveComplementarySystem)
        ? model.context.configurations.isActiveComplementarySystem.value
        : false;

    if (isActiveComplementarySystem) {
      return (
        (ProcurementProjectAYMADValidations.isOpenContract(model) ||
          ProcurementProjectAYMADValidations.isNegotiated(model) ||
          ProcurementProjectAYMADValidations.isRestrictedContract(model) ||
          ProcurementProjectAYMADValidations.isBasedFrameworkAgreement(model)) &&
        ((ProcurementProjectAYMADValidations.isWorks(model) ||
          ProcurementProjectAYMADValidations.isGoods(model) ||
          ProcurementProjectAYMADValidations.isServices(model)) &&
          !ProcurementProjectAYMADValidations.isAssociationForInnovation(model) &&
          !ProcurementProjectAYMADValidations.isDesignContest(model))
      );
    }

    return false;
  }

  public isVisibleSelectionCriteriaAward(model: any) { // NO SE UTILIZA, ELIMINAR
    // Menores con Licitacion Electronica
    // Si es  tipo de procedimiento es distinto de AM o es un CSDA
    let condition1 = (ProcurementProjectAYMADValidations.isMinorContract(model) &&
      model.classification && model.classification.submissionMethodCode);
    let condition2 = (!ProcurementProjectAYMADValidations.isBasedFrameworkAgreement(model) ||
      (model.classification && model.classification.complementarySystem && model.classification.complementarySystem.identifier === 'CSDA<>SISTCOMPLEMENTARIO') ||
      (model.classification && model.classification.complementarySystem && model.classification.complementarySystem.identifier === 'CBAM<>SISTCOMPLEMENTARIO'));

    if (condition1) {
      return true;
    }
    if (condition2) {
      return true;
    }

    return false;

  }



  public isRequiredSelectionCriteriaAward(model: any) {
    return (
      ProcurementProjectAYMADValidations.isNegotiated(model) ||
      ProcurementProjectAYMADValidations.isCompetitiveDialogue(model) ||
      ((ProcurementProjectAYMADValidations.isOpenContract(model) ||
        ProcurementProjectAYMADValidations.isRestrictedContract(model)) &&
        ProcurementProjectAYMADValidations.isAwardingVariousCriteria(model))
    );
  }

  public isVisibleSelectionCriteria(model: any) { // NO SE UTILIZA, ELIMINAR
    return (
      ProcurementProjectAYMADValidations.isRestrictedContract(model) ||
      ProcurementProjectAYMADValidations.isCompetitiveDialogue(model) ||
      ProcurementProjectAYMADValidations.isTenderWithNegotiation(model) ||
      ProcurementProjectAYMADValidations.isNegotiatedWithoutPublicity(model)
    );
  }



  public isVisibleSpecialEconomicTerm(model: any) {
    // boolean visibleRegEconomico =(esServicioPublico && esConcesion) || esConcesionObras || esConcesionServicios;
    return (
      (ProcurementProjectAYMADValidations.isServiciesPublic(model) &&
        ProcurementProjectAYMADValidations.isConcession(model)) ||
      ProcurementProjectAYMADValidations.isWorkConcession(model) ||
      ProcurementProjectAYMADValidations.isServicesConcession(model)
    );
  }

  public isVisibleSubTypeCode(model: any) {
    let visible = false;
    visible = (ProcurementProjectAYMADValidations.isWorks(model) || ProcurementProjectAYMADValidations.isGoods(model) ||
      ProcurementProjectAYMADValidations.isServices(model));
    return visible;

  }

  public isVisible(model: any) {
    let isActiveSubTypeWorks =
      (model.context &&
        model.context.configurations &&
        model.context.configurations.isActiveSubTypeWorks)
        ? model.context.configurations.isActiveSubTypeWorks.value
        : true;
    if (isActiveSubTypeWorks) {
      return (
        !ProcurementProjectAYMADValidations.isWorkConcession(model) &&
        (ProcurementProjectAYMADValidations.isServiciesPublic(model) ||
          ProcurementProjectAYMADValidations.isGoods(model) ||
          ProcurementProjectAYMADValidations.isWorks(model))
      );
    } else {
      return (
        ProcurementProjectAYMADValidations.isServiciesPublic(model) ||
        ProcurementProjectAYMADValidations.isGoods(model)
      );
    }
  }


  public isVisibleNoticeDocumentReference(model: any) {
    // boolean visibleAnuInfPrevia = esAbierto || esRestringido || esDCompetitivo
    // || ((esPNegociado && hayPublicidad) || esLicitacionNegociada);
    let visible = (ProcurementProjectAYMADValidations.isOpenContract(model) ||
      ProcurementProjectAYMADValidations.isRestrictedContract(model) ||
      ProcurementProjectAYMADValidations.isCompetitiveDialogue(model) ||
      ProcurementProjectAYMADValidations.isTenderWithNegotiation(model));

    if (visible && !ProcurementProjectAYMADValidations.isApplicableLegislationLCSP_RDL_3_20(model)) {
      return true;
    } else {
      return false;
    }
  }

  public isVisibleNoticeDocumentReferenceRDL_3_20(model: any) {
    // boolean visibleAnuInfPrevia = esAbierto || esRestringido || esDCompetitivo
    // || ((esPNegociado && hayPublicidad) || esLicitacionNegociada);
    let visible = (ProcurementProjectAYMADValidations.isOpenContract(model) ||
      ProcurementProjectAYMADValidations.isRestrictedContract(model) ||
      ProcurementProjectAYMADValidations.isCompetitiveDialogue(model) ||
      ProcurementProjectAYMADValidations.isTenderWithNegotiation(model));

    if (visible && model.applicableLegislation.identifier && model.applicableLegislation.identifier === '70<>VERSIONNORMATIVA') {
      return true;
    } else {
      return false;
    }
  }


  public provisionalGuaranteeAmount(model: any) {
    if (
      model.breakdownLot.totalLots.budget.provisionalGuaranteePercentage !=
      undefined
    ) {
      let amountGuarantee =
        model.budget != undefined &&
          model.budget.amountExcludingTaxes != undefined
          ? model.budget.amountExcludingTaxes
          : 0;
      if (ProcurementProjectAYMADValidations.isComplementarySystemAM_SDA(model)) {
        amountGuarantee = ProcurementProjectAYMADValidations.amountEstimatedAmount(
          model
        );
      }
      return (
        (amountGuarantee *
          model.breakdownLot.totalLots.budget.provisionalGuaranteePercentage) /
        100
      );
    }
    return undefined;
  }

  public static isComplementarySystem_CBAM_CSDA(model: any) {
    if (model.classification && model.classification.complementarySystem) {
      let complementarySystemBased =
        model.classification.complementarySystem === undefined
          ? false
          : model.classification.complementarySystem.identifier ==
          'CBAM<>SISTCOMPLEMENTARIO' ||
          model.classification.complementarySystem.identifier ==
          'CSDA<>SISTCOMPLEMENTARIO';
      return complementarySystemBased;
    }
    return false;
  }

  public isBasedFrameworkAgreement(model: any) {
    let isActiveComplementarySystem =
      (model.context &&
        model.context.configurations &&
        model.context.configurations.isActiveComplementarySystem)
        ? model.context.configurations.isActiveComplementarySystem.value
        : false;

    if (isActiveComplementarySystem) {
      return ProcurementProjectAYMADValidations.isComplementarySystem_CBAM_CSDA(
        model
      );
    }

    return false;
  }

  public isVisibleCompanyToInviteCBAM(model: any) {
    let isCBAM = model.classification.complementarySystem && model.classification.complementarySystem.identifier === 'CBAM<>SISTCOMPLEMENTARIO';

    // Contrato Basado sin padre
    let isNoRelatedBaseContract = ProcurementProjectAYMADValidations.isNoRelatedBaseContract(model);

    // Si es un contrato basado y tiene padre
    if (isCBAM && !isNoRelatedBaseContract) {
      return true;
    } else {
      return false;
    }
  }

  public clearFromControlCompanyToInvite(model: any) {
    let isCBAM = model.classification.complementarySystem && model.classification.complementarySystem.identifier === 'CBAM<>SISTCOMPLEMENTARIO';
    let isVisibleCompanyToInvite = ProcurementProjectAYMADValidations.isMinorContract(model) || ProcurementProjectAYMADValidations.isNegotiated(model);
    return isVisibleCompanyToInvite;

  }


  private static isComplementarySystem_CSDA(model: any) {
    let isActiveComplementarySystem =
      (model.context &&
        model.context.configurations &&
        model.context.configurations.isActiveComplementarySystem)
        ? model.context.configurations.isActiveComplementarySystem.value
        : false;

    if (isActiveComplementarySystem) {
      if (model.classification && model.classification.complementarySystem) {
        let isCSDA =
          model.classification.complementarySystem === undefined
            ? false
            : (model.classification.complementarySystem.identifier === 'CSDA<>SISTCOMPLEMENTARIO')
        return isCSDA;
      }
    }

    return false;
  }



  public isVisibleCriteriaTechnicalFinancial(model: any) {
    return !ProcurementProjectAYMADValidations.isMinorContract(model) &&
      !ProcurementProjectAYMADValidations.isBasedFrameworkAgreement(model) &&
      !ProcurementProjectAYMADValidations.isComplementarySystemBaseSD(model) &&
      !ProcurementProjectAYMADValidations.isOpenSimplifiedAbreviated(model)
      ;
  }

  public isVisibleWorkProgram(model: any) {
    // esObras || esConsultoria || esServicios
    let isConsultancy = ProcurementProjectAYMADValidations.isConsultancy(model);
    let isServices = ProcurementProjectAYMADValidations.isServices(model);
    let isWorks = ProcurementProjectAYMADValidations.isWorks(model);
    return (isConsultancy || isServices || isWorks);
  }

  public isVisibleSubcontractTerm(model: any) {
    return !ProcurementProjectAYMADValidations.isMinorContract(model) && !ProcurementProjectAYMADValidations.isServiciesPublic(model);
  }

  public isVisibleContractExtension(model: any) {
    return !ProcurementProjectAYMADValidations.isMinorContract(model) && !ProcurementProjectAYMADValidations.isWorks(model) && !ProcurementProjectAYMADValidations.isPrivate(model);
  }

  public valueFinalFinancialGuaranteePercentage(model: any) {
    if (model.breakdownLot.totalLots.budget.finalFinancialGuarantee) { //si se ha marcado que hay garantia definitiva
      if (model.breakdownLot.totalLots.budget.finalFinancialGuaranteePercentage) {
        return model.breakdownLot.totalLots.budget.finalFinancialGuaranteePercentage; //el valor introducido pr el usuario
      } else {
        //el valor establecido en la configuaracion
        let finalFinancialGuaranteePerc = model.context && model.context.configurations
          ? model.context.configurations.valueDefaultFinancialGuaranteePercentage.value
          : undefined;
        return finalFinancialGuaranteePerc;
      }
    } else {
      return undefined;
    }
  }



  public isVisibleLowTendersDescription(model: any) {
    return !ProcurementProjectAYMADValidations.isMinorContract(model) && !ProcurementProjectAYMADValidations.isCentralizedPurchases(model);
  }

  public isVisibleFichCriteriaTechnicalFinancial(model: any) {
    let isVisibleCriteriaTechnicalFinancial = !ProcurementProjectAYMADValidations.isMinorContract(model) &&
      !ProcurementProjectAYMADValidations.isBasedFrameworkAgreement(model) &&
      !ProcurementProjectAYMADValidations.isComplementarySystemBaseSD(model) &&
      !ProcurementProjectAYMADValidations.isOpenSimplifiedAbreviated(model)

    let isVisibleCompanyToInvite = ProcurementProjectAYMADValidations.isMinorContract(model) || ProcurementProjectAYMADValidations.isNegotiated(model);
    return isVisibleCriteriaTechnicalFinancial || isVisibleCompanyToInvite;
  }



  public isVisiblePriceRevision(model: any) {
    return ProcurementProjectAYMADValidations.isWorks(model) || model.parent.exp_11_2023;
  }

  public isVisiblePriceRevisionFormula(model: any) {
    return ProcurementProjectAYMADValidations.isWorks(model);
  }

  public isVisibleDirectAwardType(model: any) {
    let visibleDirectAwardType = false;
    visibleDirectAwardType = (model.tenderingTerm === undefined || model.tenderingTerm.offerEntitynum === undefined)
      ? false
      : model.tenderingTerm.offerEntitynum.identifier === '1<>TIPO_LICITACION_MENOR';
    return visibleDirectAwardType;
  }

  public isVisibleCategory(model: any) {
    // Desglosable en lotes el acuerdo marco
    if (ProcurementProjectAYMADValidations.isComplementarySystem_CBAM_CSDA(model)) {
      if (model.contractingSystem.originalContractingSystemID !== undefined && model.contractingSystem.originalContractingSystemID) {
        // Visible Unicamente si esta desglosado en lotes el Acuerdo Marco
        if (model.contractingSystem.originalContractingSystemID.breakdownLot &&
          model.contractingSystem.originalContractingSystemID.breakdownLot.apportioned) {
          return true;
        } else if (model.procurementProjectAM && model.procurementProjectAM.breakdownLot
          && model.procurementProjectAM.breakdownLot.apportioned) {
          return true;
        }
      }
    }
    return false;
  }



  private isSpecialAdministrative(model: any) {
    // boolean esAdministrativoEspecial = tipoExpte.equals("07") || tipoExpte.equals("09") || tipoExpte.equals("12");
    if (model.classification && model.classification.typeCode) {
      let isSpecialAdministrative =
        model.classification.typeCode === undefined
          ? false
          : (model.classification.typeCode.identifier === '07<>TIPOEXPTE' || model.classification.typeCode.identifier === '09<>TIPOEXPTE' || model.classification.typeCode.identifier === '12<>TIPOEXPTE');
      return isSpecialAdministrative;
    }
    return false;
  }


  public isVisiblePrice(model: any) {
    // !hayIngreso && (esConcesion  || esConcesionObras || esConcesionServicios)
    return (
      (!model.breakdownLot.totalLots.specialEconomicTerm.income &&
        (ProcurementProjectAYMADValidations.isConcession(model) ||
          ProcurementProjectAYMADValidations.isWorkConcession(model) ||
          ProcurementProjectAYMADValidations.isServicesConcession(model)))
    );
  }

  private static isCentralizedPurchases(model: any) {
    return ProcurementProjectAYMADValidations.isTypeMode(model, 'T');
  }

  private static isRate(model: any) {
    return (model.breakdownLot.totalLots &&
      model.breakdownLot.totalLots.specialEconomicTerm &&
      model.breakdownLot.totalLots.specialEconomicTerm.rate);
  }
  private static isCompensation(model: any) {
    return (model.breakdownLot.totalLots &&
      model.breakdownLot.totalLots.specialEconomicTerm &&
      model.breakdownLot.totalLots.specialEconomicTerm.compensation);
  }
  private static isCanon(model: any) {
    return (model.breakdownLot.totalLots &&
      model.breakdownLot.totalLots.specialEconomicTerm &&
      model.breakdownLot.totalLots.specialEconomicTerm.canon);
  }
  private static isPrice(model: any) {
    return (model.breakdownLot.totalLots &&
      model.breakdownLot.totalLots.specialEconomicTerm &&
      model.breakdownLot.totalLots.specialEconomicTerm.price);
  }

  private static isCleanBudget(model: any) {
    let subTypeCodeCorrect = ((ProcurementProjectAYMADValidations.isServiciesPublic(model) && ProcurementProjectAYMADValidations.isConcession(model)) ||
      ProcurementProjectAYMADValidations.isWorkConcession(model) ||
      ProcurementProjectAYMADValidations.isServicesConcession(model)
    );

    let notPrice = (!ProcurementProjectAYMADValidations.isPrice(model) &&
      (ProcurementProjectAYMADValidations.isCanon(model) || ProcurementProjectAYMADValidations.isRate(model) || ProcurementProjectAYMADValidations.isCompensation(model)));

    if (subTypeCodeCorrect && notPrice) {
      // Se limpia el campo Tipo Impositivo
      model.budget.taxRate = '';
      return true;
    }

    return false;
  }


  private static isNoTax(model: any) {

    let noTax = (model.budget &&
      model.budget.taxType &&
      model.budget.taxType.identifier === '0<>TIPO_IMPUESTO');

    return noTax;
  }

  public valueBudgetAmountExcludingTaxes(model: any) {
    let amountExcludingTaxes = ProcurementProjectAYMADValidations.isCleanBudget(model) &&
      (model.budget != undefined &&
        model.budget.amountExcludingTaxes != undefined)
      ? 0
      : model.budget.amountExcludingTaxes;

    return amountExcludingTaxes;
  }



  public enabledAmountExcludingTaxes(model: any) {
    return !ProcurementProjectAYMADValidations.isCleanBudget(model);
  }

  // Valor: Tipo de Impuesto
  public valueBudgetTaxType(model: any): string {
    let taxType = ProcurementProjectAYMADValidations.isCleanBudget(model)
      ? { 'identifier': '0<>TIPO_IMPUESTO' }
      : model.budget.taxType;
    return taxType;
  }

  // Habilitar: Tipo de Impuesto
  public enabledBudgetTaxType(model: any) {
    return !ProcurementProjectAYMADValidations.isCleanBudget(model);
  }

  // Visibilidad: Tabla de Anualidades
  public isVisibleBudgetAccountLine(model: any) {
    let visibleAnu = (model.classification && model.classification.complementarySystem &&
      model.classification.complementarySystem != 'AM<>SISTCOMPLEMENTARIO' && model.classification.complementarySystem != 'SDA<>SISTCOMPLEMENTARIO');
    let cleanBudget = ProcurementProjectAYMADValidations.isCleanBudget(model);

    if ((visibleAnu != undefined && visibleAnu) || !cleanBudget) {
      return true;
    }
    return false;
  }

  // Visibilidad Cofinanciacion
  public isVisibleCofinancing(model: any) {
    let cleanBudget = ProcurementProjectAYMADValidations.isCleanBudget(model);
    if (cleanBudget != undefined && !cleanBudget) {
      return true;
    }
    return false;
  }

  // Habilitar: Cofinanciación
  public enabledCofinancing(model: any) {
    return !ProcurementProjectAYMADValidations.isCleanBudget(model);
  }

  // Valor: Tipo impositivo
  public valueTaxRate(model: any) {
    let cleanBudget = ProcurementProjectAYMADValidations.isCleanBudget(model);
    let noTax = ProcurementProjectAYMADValidations.isNoTax(model);
    let taxRate = cleanBudget || noTax
      ? ''
      : model.budget.taxRate;
    return taxRate;
  }

  // Habilitar: Tipo Impositivo
  public enabledTaxRate(model: any) {
    let cleanBudget = ProcurementProjectAYMADValidations.isCleanBudget(model);
    let noTax = ProcurementProjectAYMADValidations.isNoTax(model);
    if (!cleanBudget && !noTax) {
      return true;
    }
    return false;
  }

  // Visible: Criterios de adjudicación de Acuerdos Marco (AAM-CBAM)
  public isVisibleFrameworkAgreementCriteria(model: any) {
    let isActiveComplementarySystem =
      (model.context &&
        model.context.configurations &&
        model.context.configurations.isActiveComplementarySystem)
        ? model.context.configurations.isActiveComplementarySystem.value
        : false;

    if (isActiveComplementarySystem) {
      return (model.type && model.type.identifier === 'AAM<>PROCEDIMIENTOSCONTRA')
        && (model.classification && model.classification.complementarySystem && model.classification.complementarySystem.identifier !== 'CSDA<>SISTCOMPLEMENTARIO')
    }

    return false;
  }

  private static isVisibleAccountLine(model: any) {
    let visibleAnu = (model.classification && model.classification.complementarySystem &&
      model.classification.complementarySystem != 'AM<>SISTCOMPLEMENTARIO' && model.classification.complementarySystem != 'SDA<>SISTCOMPLEMENTARIO');
    let cleanBudget = ProcurementProjectAYMADValidations.isCleanBudget(model);

    if ((visibleAnu != undefined && visibleAnu) || !cleanBudget) {
      return true;
    }
    return false;
  }

  private static isVisibleLots(model: any) {
    let isMinorContract = false;
    if (model.type) {
      isMinorContract = model.type === undefined
        ? false
        : model.type.identifier === 'M<>PROCEDIMIENTOSCONTRA';
    }
    if (isMinorContract) {
      return false;
    }

    if (ProcurementProjectAYMADValidations.isComplementarySystem_CBAM_CSDA(model)) {
      return false;
    }

    return true;
  }

  // Visible desglose presupuestario
  public isVisibleHeaderBudgetBreakdown(model: any) {
    // Se visualiza la cabecera de desglose presuouestario, si existen anualidades o lotes
    let visibleBudgetAccountLine = ProcurementProjectAYMADValidations.isVisibleAccountLine(model);
    let visibleLotsPanel = ProcurementProjectAYMADValidations.isVisibleLots(model) && model.breakdownLot && model.breakdownLot.apportioned;
    if (visibleBudgetAccountLine || visibleLotsPanel) {
      return true;
    } else {
      return false;
    }

  }

  // Visible Garantia provisional
  public isVisibleprovisionalGuarantee(model: any) {
    // !esMenor && !esComprasCC && !esAbiertoSimpli
    if (!ProcurementProjectAYMADValidations.isMinorContract(model) && !ProcurementProjectAYMADValidations.isCentralizedPurchases(model)
      && !ProcurementProjectAYMADValidations.isCentralizedPurchases(model)) {
      return true;
    }
    return false;
  }


  public visibleFrameworkAgreementCriteria(model: any) {
    if (model.classification && model.classification.complementarySystem) {
      let isAM =
        model.classification.complementarySystem.identifier === 'AM<>SISTCOMPLEMENTARIO';

      // Si es un contrato basado y no tiene padre
      let isCBAM =
        model.classification.complementarySystem.identifier === 'CBAM<>SISTCOMPLEMENTARIO';

      return (isAM || isCBAM);
    }
    return false;
  }

  public isVisibleCriteriaConcretion(model: any) {
    // Solo es visible si tiene seleccionado la opcion "NO"
    if (model.classification && model.classification.complementarySystem) {
      let isAM =
        model.classification.complementarySystem.identifier === 'AM<>SISTCOMPLEMENTARIO';
      // Si es un contrato basado y no tiene padre
      let isCBAM =
        model.classification.complementarySystem.identifier === 'CBAM<>SISTCOMPLEMENTARIO';

      let isFrameworkAgreementCriteria = false;
      if (model.contractingSystem != null && model.contractingSystem.frameworkAgreementCriteria != null) {
        isFrameworkAgreementCriteria = model.contractingSystem.frameworkAgreementCriteria;
      } else {
        isFrameworkAgreementCriteria = null;
      }

      // Hay que verificar si esta activo la funcionalidad de expediente base sin padre
      let baseContractNoRelated = ProcurementProjectAYMADValidations.isActiveBaseContractNoRelated(model)
        && model.contractingSystem && model.contractingSystem.baseContractNoRelated;

      if (isAM || (isCBAM && (!baseContractNoRelated))) {
        if (isFrameworkAgreementCriteria != null && !isFrameworkAgreementCriteria) {
          return true;
        } else {
          return false;
        }
        // Contrato Basado sin padre
      } else if (isCBAM && (baseContractNoRelated)) {
        if (isFrameworkAgreementCriteria != null && isFrameworkAgreementCriteria) {
          return true;
        } else {
          return false;
        }
      }
    }
    return false;
  }

  public static isActiveBaseContractNoRelated(model: any) {
    let activeBaseContractNoRelated =
      (model.context &&
        model.context.configurations &&
        model.context.configurations.isBaseContractNoRelated)
        ? model.context.configurations.isBaseContractNoRelated.value
        : false;

    if (activeBaseContractNoRelated) {
      return true;
    } else {
      return false;
    }
  }

  public isCatalogProcurementProject(model: any) {
    // Si es un contrato basado
    if (
      model.contractingSystem &&
      model.contractingSystem.originalContractingSystemID
    ) {
      let contractFolderId =
        model.contractingSystem.originalContractingSystemID.contractFolderId;

      if (contractFolderId && model.desglosableInfo['requestedMaterial']) {
        return model.desglosableInfo['requestedMaterial'].filter((material: RequestMaterialDTO) => {
          return (material.catalogId != undefined && material.catalogId != null);
        }).length > 0;
      }
    }
    return false;
  }



  public isVisibleBaseContractNoRelated(model: any) {
    let isCBAM = model.classification && model.classification.complementarySystem
      && model.classification.complementarySystem.identifier === 'CBAM<>SISTCOMPLEMENTARIO';

    if (ProcurementProjectAYMADValidations.isActiveBaseContractNoRelated(model) && isCBAM) {
      return true;
    }
    return false;
  }



  public isEnabledFrameworkAgreementCriteria(model: any) {
    let enabled = true;
    if (model.classification && model.classification.complementarySystem) {

      let isCBAM =
        model.classification.complementarySystem.identifier === 'CBAM<>SISTCOMPLEMENTARIO';

      let baseContractNoRelated = model.contractingSystem && model.contractingSystem.baseContractNoRelated;

      if (isCBAM && !baseContractNoRelated) {
        enabled = false;
      }
    }
    return enabled;
  }

  // Contrato Basado con Acuerdo Marco Padre
  public isActiveBaseContractRelated(model: any) {
    let baseContractNoRelated = false;
    baseContractNoRelated = ProcurementProjectAYMADValidations.isActiveBaseContractNoRelated(model)
      && model.contractingSystem && model.contractingSystem.baseContractNoRelated;

    if (model.classification && model.classification.complementarySystem) {
      let isCSDA = model.classification.complementarySystem.identifier === 'CSDA<>SISTCOMPLEMENTARIO';
      let isCBAM = model.classification.complementarySystem.identifier === 'CBAM<>SISTCOMPLEMENTARIO';

      if (isCSDA || isCBAM) {
        if (!baseContractNoRelated) {
          return true;
        }
      } else {
        return false;
      }
    }
    return false;
  }

  // Contrato Basado sin Padre
  public static isNoRelatedBaseContract(model: any) {
    let propertyBaseContractNoRelated = ProcurementProjectAYMADValidations.isActiveBaseContractNoRelated(model);
    let CBAMNoRelated = false;

    // Si esta activa la propiedad y esta seleccionado la opcion de si
    if (propertyBaseContractNoRelated && model.contractingSystem && model.contractingSystem.baseContractNoRelated
      && model.contractingSystem.baseContractNoRelated === true) {
      CBAMNoRelated = true;
    }
    return CBAMNoRelated;
  }



  public visibleRequestedMaterial_CBAM_CSDA(model: any) {
    if (model.classification && model.classification.complementarySystem) {
      let isCSDA = model.classification.complementarySystem.identifier === 'CSDA<>SISTCOMPLEMENTARIO';
      let isCBAM = model.classification.complementarySystem.identifier === 'CBAM<>SISTCOMPLEMENTARIO';

      let isNoRelatedBaseContract = ProcurementProjectAYMADValidations.isNoRelatedBaseContract(model);
      // Si tiene padre el contrato basado, se introducen los materiales del padre
      if (isCSDA || (isCBAM && !isNoRelatedBaseContract)) {
        return true;
      }
    }
    return false;
  }


  // FUNCIONES PRESUPUESTO

  private updateBudgetTotalTaxes(model: any) {
    if (model.budget?.taxType?.identifier) {
      if (ProcurementProjectAYMADValidations.isNoTax(model)) {
        // Exento de IVA
        model.budget.totalTaxes = 0;
      } else if (model.budget.taxType.identifier !== '998<>TIPO_IMPUESTO' && model.budget.taxType.identifier !== '1<>TIPO_IMPUESTO'
        && !model.budget.manualCalculation) {
        // no es Varios Tipos, ni  IVAincluido
        model.budget.totalTaxes = this.round((model.budget.taxType?.properties?.PORCENTAJE || 0)
          * (model.budget.amountExcludingTaxes || 0) / 100);
      }
    } else {
      // Si no se ha seleccionado ningún tipo de impuesto, es necesario limpiar el valor de todos los campos
      // model.budget.amountExcludingTaxes = 0;
      model.budget.totalTaxes = 0;
      //model.budget.amountExcludingTaxes = 0;
    }
  }

  private updateTaxRateMinor(model: any) {
    if (ProcurementProjectAYMADValidations.isMinorContract(model)) {
      if (model.budget?.taxType?.identifier) {
        if (model.budget.taxType.identifier !== '998<>TIPO_IMPUESTO'
          && model.budget.taxType.identifier !== '998<>TIPO_IMPUESTO') {
          return '';
        } else {
          return model.budget.taxRate;
        }
      }
    }
  }

  private updatedBudgetTaxType(model: any) {
    if (model.budget?.taxType?.identifier) {
      if (model.budget.taxType.identifier === '998<>TIPO_IMPUESTO') {
        model.budget.lotManualCalculation = true;
      }
      if (model.budget.taxType.identifier === '0<>TIPO_IMPUESTO') {
        model.budget.lotManualCalculation = false;
      }
    }
  }

  private round(value: number, digits = 2): number {
    let multiplier = Math.pow(10, digits);
    return Math.round((value + Number.EPSILON) * multiplier) / multiplier;
  }

  public updateTotalAmount(model: any) {
    let total = (model.budget.amountExcludingTaxes || 0) + (model.budget.totalTaxes || 0);
    // let digits = 2;
    // let multiplier = Math.pow(10, digits);
    model.budget.totalAmount = this.round(total); // Math.round((total + Number.EPSILON) * multiplier) / multiplier;
  }

  public updateBudgetData(model: any): void {
    // actualizar total impuesto
    this.updateBudgetTotalTaxes(model);
    // actualizar importe final
    this.updateTotalAmount(model);
    // Se actualiza el desplegable de Calculo Manual
    this.updatedBudgetTaxType(model);
    // Actualizar Tipo Impositivo
    this.updateTaxRateMinor(model);

  }


  //////  FUNCIONES PARA GOBERNANZA /////
  public editableNumLicitableLots(model: any) {
    if (model.breakdownLot && model.breakdownLot.apportioned && model.breakdownLot.tenderAllLots) {
      return false;
    } else {
      return true;
    }
  }
  public valueCategory(model: any) {
    let visibleCategory = false;
    let cleanValue = false;
    if (ProcurementProjectAYMADValidations.isComplementarySystem_CBAM_CSDA(model)) {
      if (model.contractingSystem.originalContractingSystemID != undefined && model.contractingSystem.originalContractingSystemID) {
        // Visible Unicamente si esta desglosado en lotes el Acuerdo Marco
        if (model.contractingSystem.originalContractingSystemID.breakdownLot && model.contractingSystem.originalContractingSystemID.breakdownLot.apportioned) {
          visibleCategory = true;
        } else if (model.procurementProjectAM && model.procurementProjectAM.breakdownLot && model.procurementProjectAM.breakdownLot.apportioned) {
          visibleCategory = true;
        } else {
          // Para que almacene un valor
          cleanValue = false;
        }
      }
    }
    return false;

  }

  /*public valueUrgencyCode(model:any){
    if (model.context.configurations.isApplicableLegislationLCSP_RDL_3_20.value){
      return
    }

  }*/


  public static isApplicableLegislationLCSP_RDL_3_20(model: any) {
    if (model.applicableLegislation.identifier && model.applicableLegislation.identifier === '70<>VERSIONNORMATIVA') {
      return true;
    } else {
      return false;
    }
  }

  public clearHarmonizedRegulationRDL_3_20(model: any) {
    if (ProcurementProjectAYMADValidations.isApplicableLegislationLCSP_RDL_3_20(model)) {
      return false;
    } else {
      return true;
    }
  }

  public isVisiblePenaltyClauses(model: any) {
    // Se visualiza para la normativa distinto de 70
    let visible = !ProcurementProjectAYMADValidations.isMinorContract(model) && !ProcurementProjectAYMADValidations.isServiciesPublic(model);

    if (visible && !ProcurementProjectAYMADValidations.isApplicableLegislationLCSP_RDL_3_20(model)) {
      return true;
    } else {
      return false;
    }
  }

  public isVisiblePenaltyClausesOther(model: any) {
    // No se visualiza para la normativa 70
    let visible = !ProcurementProjectAYMADValidations.isMinorContract(model) && !ProcurementProjectAYMADValidations.isServiciesPublic(model);

    if (visible && ProcurementProjectAYMADValidations.isApplicableLegislationLCSP_RDL_3_20(model)) {
      return true;
    } else {
      return false;
    }

  }

  /****************************FUNCIONES ASOCIADAS A LOS MODOS*********************************/
  /* Utilizadas desde las pantallas */

  // Metodo generico que devuelve si es el modo pasado por parametro
  public static isMode(model: any, mode: string, configurationsMode: any) {

    if (model.type) {
      if (model.type.identifier === mode) {
        return true;
      } else {
        let isModes = false;
        if (model.context && model.context.configurations && configurationsMode != undefined) {
          isModes = configurationsMode.value.some(
            t => t === model.type.identifier
          );
        }
        return isModes;
      }
    }
    return false;
  }

  // Metodo que indica si el tipo de procedimiento por pantalla contiene el modo asociado
  public static isTypeMode(model: any, mode: string) {

    let modes: string;
    let type: string;
    let t: string;

    if (model.parent != undefined && model.parent) {
      model = model.parent;
    }

    if (model.type) {
      t = model.type.identifier;
      // Selecciona el identificador
      let type = t.substr(0, t.indexOf('<'));    //'M<>PROCEDIMIENTOSCONTRA'
      if (type === mode) {
        return true;
      } else {
        let existMode = false;
        if (model.context && model.context.configurations && model.context.configurations.typeModes != undefined) {
          modes = model.context.configurations.typeModes.value[type];
          /*if (modes.indexOf(mode) != -1) {
            return true;
          }*/
          let tModes = modes.split(";");
          tModes.forEach((value, index) => {
            if (tModes[index] === mode) {
              existMode = true;
            }
          });
        }
        return existMode;
      }
    }
    return false;
  }

  // MODO: MENOR
  //esMenor = modoProc.equals("M")
  public isMinorContractMode(model: any) {
    return ProcurementProjectAYMADValidations.isTypeMode(model, 'M');
  }

  // MODO: ABIERTO
  //esAbierto =  modoProc.equals("A")
  public isOpenContractMode(model: any) {
    return ProcurementProjectAYMADValidations.isTypeMode(model, 'A');
  }

  // MODO: NEGOCIADO
  //esNegociado = modoProc.equals("N")
  public isNegotiatedMode(model: any) {
    return ProcurementProjectAYMADValidations.isTypeMode(model, 'N');
  }

  // MODO: RESTRINGIDO
  //esNegociado = modoProc.equals("R")
  public isRestrictedMode(model: any) {
    return ProcurementProjectAYMADValidations.isTypeMode(model, 'R');;
  }

  // MODO: DIALOGO COMPETITIVO modesCompetitiveDialogue
  //  esDialogoCompetitivo = modoProc.equals("DC")
  public isCompetitiveDialogueMode(model: any) {
    return ProcurementProjectAYMADValidations.isTypeMode(model, 'DC');
  }

  // MODO: ADJUDICACION DE ACUERDO MARCO
  // esAdjudicacion de AM
  public isBasedFrameworkAgreementMode(model: any) {
    return ProcurementProjectAYMADValidations.isTypeMode(model, 'AAM');
  }

  // MODO: COMPRAS CENTRALIZADAS
  public isCentralizedPurchases(model: any) {
    return ProcurementProjectAYMADValidations.isTypeMode(model, 'T');
  }

  // FUNCIONES PROPIAS AYUMAD /////////////



  private static isSeveralTaxes(model: any) {

    let isSeveralTax = (model.budget &&
      model.budget.taxType &&
      model.budget.taxType.identifier === '998<>TIPO_IMPUESTO');

    return isSeveralTax;
  }



  private static isManualCalculationTaxes(model: any) {

    let noTax = (model.budget &&
      model.budget.taxType &&
      model.budget.taxType.identifier === '999<>TIPO_IMPUESTO');

    let isManual = (model.budget &&
      model.budget.manualCalculation);

    if (model.parent != undefined && model.parent) {
      isManual = (model.budget &&
        model.budget.lotManualCalculation);
    }
    return noTax || isManual;
  }



  public enabledBudgetTotalTaxes(model: any) {


    if (ProcurementProjectAYMADValidations.isSeveralTaxes(model) ||
      (ProcurementProjectAYMADValidations.isManualCalculationTaxes(model) && !ProcurementProjectAYMADValidations.isNoTax(model))) {
      return true;
    }
    return false;

    /* Asi es como estaba en producto
    if (!cleanBudget && !noTax) {
      return true;
    }
    return false;*/
  }



  // FICHA EXPEDIENTE CONTRATACION //

  public isVisibleProcessJustificationNegotiated(model: any) {
    // Tiene que existir valor en el campo de Tipo de Procedimiento y Tipo de Expediente
    // Si no el buscador no tendría datos

    if (model.type && model.type.identifier != undefined) {
      return ProcurementProjectAYMADValidations.isNegotiated(model);
    } else {
      return false;
    }
  }

  public isVisibleProcurementCommittee(model: any) {
    let visible = false;
    if (model.type && model.type.identifier != undefined) {
      if (model.type.identifier === 'NSP<>PROCEDIMIENTOSCONTRA') {
        visible = true;
      }
    }
    return visible;
  }

  // De momento NO SE USA, porque cuando se visualiza siemre está habilitada el check de Mesa de Contratación
  public isEnabledProcurementCommittee(model: any) {
    /*return (
      !ProcurementProjectAYMADValidations.isTenderWithNegotiation(model)
    );*/
    return true;
  }

  // De momento NO SE USA, porque cuando se visualiza siemre está habilitada el check de Mesa de Contratación
  public valueProcurementCommittee(model: any) {
    if (ProcurementProjectAYMADValidations.isTenderWithNegotiation(model)) {
      return true;
    } else if (ProcurementProjectAYMADValidations.isNegotiatedWithoutPublicity(model) || ProcurementProjectAYMADValidations.isBasedFrameworkAgreement(model) || ProcurementProjectAYMADValidations.isTypeMode(model, 'N')) {
      return model.classification.procurementCommittee;
    } else {
      return null;
    }
  }

  public valueFinancingSuspCond(model: any) {
    if (model.classification && model.classification.expenseCode) {
      return false;
    } else { return model.characteristicsContractObject.financingSuspCond; }
  }

  public enabledFinancingSuspCond(model: any) {
    if (model.classification && model.classification.expenseCode) {
      return false;
    }
    return true;
  }

  public valueChangeExpenseCode(model: any) {
    if (model.classification && model.classification.expenseCode) {
      model.characteristicsContractObject.financingSuspCond = false;
    }
  }

  public enabledExpenseCode(model: any) {
    if (model.characteristicsContractObject && model.characteristicsContractObject.financingSuspCond != undefined && model.characteristicsContractObject.financingSuspCond) {
      return false;
    }
    return true;


  }

  public isVisibleLotsPanel(model: any) {
    if (model.type) {
      let isMinorContract = ProcurementProjectAYMADValidations.isMinorContract(model);

      if (isMinorContract || ProcurementProjectAYMADValidations.isComplementarySystem_CBAM_CSDA(model)) {
        return false;
      }
      return true;
    }
    return false;
  }

  public isUniquePriceCriteria(model: any) {
    if (model.parent != undefined && model.parent) {
      model = model.parent;
    }
    if (model.classification?.awardMethod?.identifier === 'U<>FORMASADJUDICACION') {
      return true;
    }
    return false;
  }

  public isSimplifiedOpen(model: any) {
    if (model.parent != undefined && model.parent) {
      model = model.parent;
    }
    let isSimplifiedOpen = false;
    if (model.type) {
      isSimplifiedOpen = model.type.identifier === 'AS<>PROCEDIMIENTOSCONTRA';

    }
    return isSimplifiedOpen;
  }

  // Si es Negociado,la Forma de Adjudicación es Pluralidad de Criterios
  public valueAwardMethod(model: any) {
    if (ProcurementProjectAYMADValidations.isTypeMode(model, 'N')) {
      return {
        identifier: 'P<>FORMASADJUDICACION',
        description: 'Pluralidad de Criterios'
      };
    }
    return model.classification.awardMethod;
  }

  public visibleMainContractNumber(model: any) {
    let visible = true;

    if (ProcurementProjectAYMADValidations.isConsultancy(model) || ProcurementProjectAYMADValidations.isServices(model)) {
      if ((model.characteristicsContractObject.complementaryWorks != undefined && model.characteristicsContractObject.complementaryWorks) ||
        (model.characteristicsContractObject.complementaryOthers != undefined && model.characteristicsContractObject.complementaryOthers)) {
        return true;
      }
    }
    return false;

  }


  public valueConfidentialityPeriod(model: any) {

    if (model.exp_Rdl_14_2019 !== undefined && model.exp_Rdl_14_2019) {
      if (!model.characteristicsContractObject.confidentialityPeriod) {
        return '5 años desde el conocimiento de esa información';
      }
    } else {
      if (model.characteristicsContractObject.activeConfidentialityPeriod !== undefined && model.characteristicsContractObject.activeConfidentialityPeriod) {
        if (!model.characteristicsContractObject.confidentialityPeriod) {
          return '5 años';
        }
      }
    }
    return model.characteristicsContractObject.confidentialityPeriod;
  }

  // FUNCIONES - FICHA EXPTE DOS PASOS- FUNCIONES PASO 2 //
  private static isApportioned(model: any) {
    if (!(model instanceof ProcurementProjectDTO)) {
      model = model.parent;
    }
    if (model?.breakdownLot?.apportioned != undefined && model?.breakdownLot?.apportioned != null && model?.breakdownLot?.apportioned) {
      return true;
    }
    return false;
  }

  public visibleScheduledSubrogationLot(model: any) {

    let isApportionedStep2 = ProcurementProjectAYMADValidations.isApportioned(model);

    if (model.parent.classification && model.parent.classification.typeCode) {
      let isServices =
        model.parent.classification.typeCode === undefined
          ? false
          : model.parent.classification.typeCode.identifier === '04<>TIPOEXPTE';

      return (isServices && isApportionedStep2);
    }
    return false;

  }

  public visibleSubrogationUnfulfillment(model: any) {
    let isApportionedStep2 = ProcurementProjectAYMADValidations.isApportioned(model);
    let isServices = ProcurementProjectAYMADValidations.isServices(model);
    let scheduledSubrogationStep1 = model.parent.characteristicsContractObject?.scheduledSubrogation != null
      && model.parent.characteristicsContractObject.scheduledSubrogation;
    let visible = isServices && scheduledSubrogationStep1;
    if (isApportionedStep2) {
      let scheduledSubrogationStep2 = model.scheduledSubrogation != null && model.scheduledSubrogation;
      visible = visible && scheduledSubrogationStep2;
    } else {
      // No hay lotes. Le establecemos el valor al campo.
      if (visible) {
        model.execution.subrogationUnfulfillment = true;
      }
    }
    return visible;
  }

  public setValueSubrogationUnfulfillment(model: any) {
    let isApportionedStep2 = ProcurementProjectAYMADValidations.isApportioned(model);
    let isServices = ProcurementProjectAYMADValidations.isServices(model);
    let scheduledSubrogationStep1 = model.parent.characteristicsContractObject?.scheduledSubrogation != null
      && model.parent.characteristicsContractObject.scheduledSubrogation;
    let visible = isServices && scheduledSubrogationStep1;
    if (isApportionedStep2) {
      let scheduledSubrogationStep2 = model.scheduledSubrogation != null && model.scheduledSubrogation;
      visible = visible && scheduledSubrogationStep2;
    }
    if (visible) {
      model.execution.subrogationUnfulfillment = true;
    }
  }

  public setValueScheduledSubrogation(model: any) {
    let isApportionedStep2 = ProcurementProjectAYMADValidations.isApportioned(model);

    if (model.parent.classification && model.parent.classification.typeCode) {
      let isServices =
        model.parent.classification.typeCode === undefined
          ? false
          : model.parent.classification.typeCode.identifier === '04<>TIPOEXPTE';

      if (isServices && isApportionedStep2) {
        if (model.parent.characteristicsContractObject?.scheduledSubrogation != null
          && !model.parent.characteristicsContractObject.scheduledSubrogation) {
          return false;
        }
      }
    }
    //return model.parent.characteristicsContractObject?.scheduledSubrogation;
    return model.scheduledSubrogation;
  }

  public editablecheduledSubrogation(model: any) {
    // si está desglosado en lotes
    let isApportionedStep2 = ProcurementProjectAYMADValidations.isApportioned(model);

    if (model.parent.classification && model.parent.classification.typeCode) {
      let isServices =
        model.parent.classification.typeCode === undefined
          ? false
          : model.parent.classification.typeCode.identifier === '04<>TIPOEXPTE';

      if (isServices && isApportionedStep2) {
        if (model.parent.characteristicsContractObject?.scheduledSubrogation != null
          && !model.parent.characteristicsContractObject.scheduledSubrogation) {
          return false;
        }
      }
    }
    return true;
  }


  public isApportioned(model: any) {
    if (!(model instanceof ProcurementProjectDTO)) {
      model = model.parent;
    }
    if (model?.breakdownLot?.apportioned != undefined && model?.breakdownLot?.apportioned != null && model?.breakdownLot?.apportioned) {
      return true;
    }
    return false;
  }
  public isExp_Rdl_14_2019(model: any) {
    if (!(model instanceof ProcurementProjectDTO)) {
      model = model.parent;
    }
    if (model?.exp_Rdl_14_2019 != undefined && model?.exp_Rdl_14_2019 != null && model.exp_Rdl_14_2019) {
      return true;
    }
    return false;
  }

  public isVisibleBudgetDeterminationSystem(model: any) {
    return ((ProcurementProjectAYMADValidations.isConsultancy(model) || ProcurementProjectAYMADValidations.isServices(model)));
  }

  public valueBudgetTypeLot(model: any) {
    let apportioned = model.parent?.breakdownLot?.apportioned;
    let isWorks = ProcurementProjectAYMADValidations.isWorks(model);

    if (isWorks) {
      return {
        identifier: '5<>TIPO_PRESUPUESTO',
        description: 'Máximo determinado'
      };
    } else {
      return model.budget.budgetType;
    }

  }

  public enabledBudgetManualCalculationLot(model: any) {
    let isSeveralTax = (model.budget &&
      model.budget.taxType &&
      model.budget.taxType.identifier === '998<>TIPO_IMPUESTO');

    let noTax = (model.budget &&
      model.budget.taxType &&
      model.budget.taxType.identifier === '0<>TIPO_IMPUESTO');


    if (isSeveralTax || noTax) {
      return false;
    } else {
      return true;
    }

  }

  public visibleCanonAmountLot(model: any) {
    // Dependiendo de si tiene lotes o no, tiene visibilidad diferente
    // Es Arrendamiento
    let isLease = (model.parent?.classification?.subTypeCode?.identifier === '04<>MODALIDADEXPTE') ||
      (model.parent?.classification?.subTypeCode?.identifier === '08<>MODALIDADEXPTE');
    let isGoods = model.parent.classification.typeCode.identifier === '02<>TIPOEXPTE';

    if (isGoods) {
      if (isLease) {
        return true;
      }
    }
    return false;
  }

  public visiblePriceIncreaseLot(model: any) {
    let isBudgetDetermination = false;
    let isExecTimeUnit = false;

    if (model.budget && model.budget.budgetDetermination && model.budget.budgetDetermination) {
      isBudgetDetermination = true;
    }

    if (model.budget.budgetDeterminationSystems != undefined && model.budget.budgetDeterminationSystems.length > 0)
      model.budget.budgetDeterminationSystems.forEach((budgetDetSystem: BudgetDeterminationSystem) => {
        // generar objeto company
        if (budgetDetSystem?.budgetDeterminationSystem?.identifier != undefined && budgetDetSystem?.budgetDeterminationSystem?.identifier === '11<>SISTDETPRESUPUESTO') {
          isExecTimeUnit = true;
        }
      });

    let visible = false;
    visible = ((ProcurementProjectAYMADValidations.isGoods(model) && isBudgetDetermination) || (ProcurementProjectAYMADValidations.isServices(model) && isExecTimeUnit))
    return visible;
  }
  public visiblePriceDeterminationLot(model: any) {
    if (model.budget && model.budget.budgetDetermination != undefined && model.budget.budgetDetermination != null && !model.budget.budgetDetermination) {
      if (ProcurementProjectAYMADValidations.isGoods(model))
        return true;
    }
    return false;
  }
  public visibleOthersCriteriaTechnicalFinancialLot(model: any) {
    return ProcurementProjectAYMADValidations.isGoods(model);
  }

  public isVisibleClassificationCompany(model: any) {
    return (ProcurementProjectAYMADValidations.isWorks(model) || ProcurementProjectAYMADValidations.isServices(model));

  }

  public editableFileds_UnitPrice(model: any) {
    if (model?._parent?.budget?.manualTaxCalculation === undefined ||
      (model?._parent?.budget?.manualTaxCalculation != undefined && model?._parent?.budget?.manualTaxCalculation)) {
      return false;
    } else {
      return true;
    }

  }

  public valueTotalAmount_UnitPrice(model: any) {
    if (model?._parent?.budget?.manualTaxCalculation === undefined || (model?._parent?.budget?.manualTaxCalculation != undefined && model?._parent?.budget?.manualTaxCalculation)) {
      let total = (model.amountExcludingTaxes || 0) + (model.totalTaxes);
      let digits: number = 4;
      let multiplier = Math.pow(10, digits);
      return Math.round((total + Number.EPSILON) * multiplier) / multiplier;
    } else {
      return (model?.totalAmount != undefined ? model?.totalAmount : undefined)
    }
  }

  public isVisibleAwardCriteriaLot(model: any) {
    // Menores con Licitacion Electronica
    // Si es  tipo de procedimiento es distinto de AM o es un CSDA

    let condition1 = (ProcurementProjectAYMADValidations.isNegotiated(model));
    let condition2 = ((ProcurementProjectAYMADValidations.isOpenContract(model) ||
      ProcurementProjectAYMADValidations.isRestrictedContract(model)) &&
      ProcurementProjectAYMADValidations.isAwardingVariousCriteria(model))

    if (condition1 || condition2) {
      return true;
    }
    return false;

  }

  public setTextObjectiveCriteriaDesc(model: any) {
    let textNegociated = 'Aspectos objeto de la negociación';
    let textOpenOrRestricted = 'Evaluables mediante fórmulas (criterios objetivos)';
    let finalText = ProcurementProjectAYMADValidations.isTypeMode(model, 'N') ? textNegociated : textOpenOrRestricted;
    return finalText;
  }

  public setTextExistSubjectiveCriteria(model: any) {
    let textNegociated = 'Criterios de Adjudicación';
    let textOpenOrRestricted = 'Existen criterios evaluables mediante juicio de valor (criterios subjetivos)';
    let finalText = ProcurementProjectAYMADValidations.isTypeMode(model, 'N') ? textNegociated : textOpenOrRestricted;
    return finalText;
  }

  public getValueNIDLowerTender(model: any) {
    let rowIndex = 0;
    if (model?.rowUuid && model?._parent) {
      let index = 0;
      model?._parent.lowerTender.forEach((lowerTender) => {
        if (lowerTender.rowUuid === model?.rowUuid) {
          rowIndex = index;
        }
        index++;
      });

    }
    return rowIndex;
  }

  public isVisibleSelectionCriteriaLot(model: any) { // NO SE UTILIZA, ELIMINAR
    return (
      ProcurementProjectAYMADValidations.isRestrictedContract(model) ||
      ProcurementProjectAYMADValidations.isTenderWithNegotiation(model)

    );
  }

  private static roundDecimals(value: number, decimals?: number): number {
    let digits: number = (decimals || decimals === 0) ? decimals : 2;
    let multiplier = Math.pow(10, digits);
    return Math.round((value + Number.EPSILON) * multiplier) / multiplier;
  }




  public valueProvisionalGuaranteePercentage(model: any) {
    let budgetTypeEstimatedMax = model.budget.budgetType && model.budget.budgetType.identifier !== undefined
      && model.budget.budgetType.identifier === '2<>TIPOPRESUPUESTO';
    let budgetTypeDeterminatedMax = model.budget.budgetType && model.budget.budgetType.identifier !== undefined
      && model.budget.budgetType.identifier === '5<>TIPOPRESUPUESTO';

    let amountGuarantee = 0;
    //let percentage = 0;

    if (budgetTypeEstimatedMax || budgetTypeDeterminatedMax) {
      // Importe Sin Iva
      if (model.budget && model.budget.amountExcludingTaxes !== undefined) {
        amountGuarantee = model.budget.amountExcludingTaxes;
      }
    } else {
      // Importe con Iva
      if (model.budget && model.budget.totalAmount !== undefined) {
        amountGuarantee = model.budget.totalAmount;
      }
    }

    if (model.budget.provisionalGuarantee) { // si se ha marcado que hay garantia definitiva
      if (amountGuarantee === undefined || (amountGuarantee !== undefined && amountGuarantee === 0)) {
        model.budget.provisionalGuaranteePercentage = 0;
      } else {
        if (model.budget && model.budget.provisionalGuaranteeAmount !== undefined && model.budget.provisionalGuaranteeAmount !== 0) {
          let valueProvGuaranteePerc = 0;
          valueProvGuaranteePerc = ProcurementProjectAYMADValidations.
            roundDecimals(((model.budget.provisionalGuaranteeAmount / amountGuarantee) * 100), 2);
          model.budget.provisionalGuaranteePercentage = valueProvGuaranteePerc;
        }
      }
    }
  }

  // REPASAR DECIMALES
  public valueProvisionalGuarantee(model: any) {

    let budgetTypeEstimatedMax = model.budget.budgetType
      && model.budget.budgetType.identifier !== undefined && model.budget.budgetType.identifier === '2<>TIPOPRESUPUESTO';
    let budgetTypeDeterminatedMax = model.budget.budgetType
      && model.budget.budgetType.identifier !== undefined && model.budget.budgetType.identifier === '5<>TIPOPRESUPUESTO';

    let amountGuarantee = 0;
    let amountGaranteeProv = 0;

    if (model.budget.provisionalGuarantee) {
      if (budgetTypeEstimatedMax || budgetTypeDeterminatedMax) {
        // Importe Sin Iva
        if (model.budget && model.budget.amountExcludingTaxes !== undefined) {
          amountGuarantee = model.budget.amountExcludingTaxes;
        }
      } else {
        // Importe con Iva
        if (model.budget && model.budget.totalAmount !== undefined) {
          amountGuarantee = model.budget.totalAmount;
        }
      }

      if (model.budget && model.budget.provisionalGuaranteePercentage !== undefined &&
        model.budget.provisionalGuaranteePercentage != null) {
        if (amountGuarantee !== 0 && model.budget.provisionalGuaranteePercentage !== 0) {
          amountGaranteeProv =
            ProcurementProjectAYMADValidations.roundDecimals(((amountGuarantee * model.budget.provisionalGuaranteePercentage) / 100), 2);
        }
      }
      model.budget.provisionalGuaranteeAmount = amountGaranteeProv;
    } else {
      model.budget.provisionalGuaranteeAmount = 0;
    }
  }

  public noVisibleOffersContent(model: any) {
    // boolean noVisiblePestanna = (esAbiertoSimplificado && !esPluralidadCriterios) || (esAbiertoSimplificadoAb) || (esAbiertoSimplificado && !hayCrit);

    let isSimplifiedOpen = false;


    if (model.parent && model.parent.type) {
      isSimplifiedOpen = model.parent.type.identifier === 'AS<>PROCEDIMIENTOSCONTRA';
    }
    let noVisible = (isSimplifiedOpen && !ProcurementProjectAYMADValidations.isAwardingVariousCriteria) ||
      (ProcurementProjectAYMADValidations.isOpenSimplifiedAbreviated(model)) || (isSimplifiedOpen && !model.existSubjectiveCriteria);

    return noVisible;
  }


  public setTextotherDocsEnvelope2(model: any) {

    let isSimplifiedOpen = false;
    let isOpenSimplifiedAbreviated = false;
    let texto = 'Sobre Criterios evaluables mediante juicio de valor (subjetivos)';

    isOpenSimplifiedAbreviated = ProcurementProjectAYMADValidations.isOpenSimplifiedAbreviated(model);

    if (model.parent && model.parent.type) {
      isSimplifiedOpen = model.parent.type.identifier === 'AS<>PROCEDIMIENTOSCONTRA';
    }

    if (!isOpenSimplifiedAbreviated && !isSimplifiedOpen) {
      // Sobre Criterios NO valorables en cifras o porcentajes
      if (ProcurementProjectAYMADValidations.isTypeMode(model, 'N')) {
        texto = 'Sobre documentación aspectos objeto negociación';
      }

    }

    return texto;
  }

  public visibleOtherDocsEnvelope2(model: any) {
    let isSimplifiedOpen = false;
    let isOpenSimplifiedAbreviated = false;
    let existCrit = false;
    existCrit = model.existSubjectiveCriteria != null && model.existSubjectiveCriteria;

    if (model.parent && model.parent.type) {
      isSimplifiedOpen = model.parent.type.identifier === 'AS<>PROCEDIMIENTOSCONTRA';
      isOpenSimplifiedAbreviated = model.parent.type.identifier === 'ASA<>PROCEDIMIENTOSCONTRA';
    }

    if (ProcurementProjectAYMADValidations.isTypeMode(model, 'N')) {
      return true;
    }
    if (existCrit) {
      if (!isSimplifiedOpen && !isOpenSimplifiedAbreviated) {
        if (ProcurementProjectAYMADValidations.isTypeMode(model, 'A') || ProcurementProjectAYMADValidations.isTypeMode(model, 'R')) {
          return true;
        }
      }
      if (isSimplifiedOpen && ProcurementProjectAYMADValidations.isAwardingVariousCriteria) {
        return true;
      }
    }

    return false;
  }

  public visibleOtherDocsEnvelope3(model: any) {
    let isSimplifiedOpen = false;
    if (model.parent && model.parent.type) {
      isSimplifiedOpen = model.parent.type.identifier === 'AS<>PROCEDIMIENTOSCONTRA';
    }

    if (!isSimplifiedOpen && !ProcurementProjectAYMADValidations.isOpenSimplifiedAbreviated(model)) {
      if (ProcurementProjectAYMADValidations.isAwardingVariousCriteria(model) && (ProcurementProjectAYMADValidations.isTypeMode(model, 'A') || ProcurementProjectAYMADValidations.isTypeMode(model, 'R'))) {
        return true
      }
    }
    return false;
  }

  public visibleAdmVarPro(model: any) {
    //(!esNegociadoSinPublic && !esLicitacionNegociacion && (esPluralidadCriterios || (esFadjUnicoCriterioPrecio && !precio))) {

    let isSimplifiedOpen = false;
    let isUniquePriceCriteria = false;

    if (model.parent && model.parent.type) {
      isSimplifiedOpen = model.parent.type.identifier === 'AS<>PROCEDIMIENTOSCONTRA';
    }
    if (model.parent.classification && model.parent.classification.awardMethod) {
      isUniquePriceCriteria = model.parent.classification.awardMethod.identifier === 'U<>FORMASADJUDICACION';
    }

    if (!isSimplifiedOpen && !ProcurementProjectAYMADValidations.isOpenSimplifiedAbreviated(model)) {
      if (!ProcurementProjectAYMADValidations.isNegotiatedWithoutPublicity(model) && !ProcurementProjectAYMADValidations.isTenderWithNegotiation(model) &&
        (ProcurementProjectAYMADValidations.isAwardingVariousCriteria(model) || (isUniquePriceCriteria && (model.parent?.tenderingTerm?.priceCriteria === null || (model.parent?.tenderingTerm?.priceCriteria != null && model.parent?.tenderingTerm?.priceCriteria != 0))))) {
        return true;
      }
    }
    return false;
  }


  public visibleQuantCritEnvelope(model: any) {
    let priceRentBased = false;
    let isUniquePriceCriteria = false;
    let isSimplifiedOpen = false;

    if (model.parent != undefined && model.parent) {
      if (model.parent.tenderingTerm && model.parent.tenderingTerm.priceCriteria) {
        priceRentBased = true;
      }
      if (model.parent.type) {
        isSimplifiedOpen = model.parent.type.identifier === 'AS<>PROCEDIMIENTOSCONTRA';
      }
      if (model.parent.classification && model.parent.classification.awardMethod) {
        isUniquePriceCriteria = model.parent.classification.awardMethod.identifier === 'U<>FORMASADJUDICACION';
      }
    }

    if (!isSimplifiedOpen && !ProcurementProjectAYMADValidations.isOpenSimplifiedAbreviated(model)) {
      if (isUniquePriceCriteria && priceRentBased) {
        return true;
      }
      return false;
    }
  }

  public isVisibleCompanyToInvite(model: any) {
    return ProcurementProjectAYMADValidations.isNegotiatedWithoutPublicity(model);
  }

  public isVisibleMethod(model: any) {
    let isVisibleMethodRevPrice = model.priceRevision &&
      model.priceRevision.priceRevision &&
      (model.priceRevision.priceRevision === 'SI' || model.priceRevision.priceRevision === 'SOLO_PRORROGA') &&
      !ProcurementProjectAYMADValidations.isWorks(model)
    return isVisibleMethodRevPrice;
  }

  public isVisibleAwardCriteriaUnfulfillment(model: any) {
    let visible = false;
    let isTenderWithNegotiation = ProcurementProjectAYMADValidations.isTenderWithNegotiation(model);
    let isNegotiatedWithoutPublicity = ProcurementProjectAYMADValidations.isNegotiatedWithoutPublicity(model);
    let isAwardingVariousCriteria = ProcurementProjectAYMADValidations.isAwardingVariousCriteria(model);
    let isOpenContract = ProcurementProjectAYMADValidations.isOpenContract(model);
    let isRestrictedContract = ProcurementProjectAYMADValidations.isRestrictedContract(model);
    let existSubjectiveCriteria = model?.existSubjectiveCriteria;
    visible = ((isTenderWithNegotiation || isNegotiatedWithoutPublicity) && existSubjectiveCriteria)
      || ((isOpenContract || isRestrictedContract) && isAwardingVariousCriteria);
    // boolean visualizaIncCritAdj = (   (esLicitacionNegociacion || esNegociadoSinPublic) && hayCrit)
    // || ((esAbierto || esRestringido) && esPluralidadCriterios);
    return visible;
  }

  //Pestaña ii.l
  public isVisibleDataWorks(model: any) {
    let visible = false;
    visible = ProcurementProjectAYMADValidations.isWorks(model);
    return visible;
  }
  public visibleTrialPercentaje(model: any) {
    let visible = false;
    let id = '';
    if (model?.worksData?.trial?.identifier && model?.worksData?.trial?.identifier.indexOf('<>') !== -1) {
      let identifier = model?.worksData?.trial?.identifier;
      id = identifier.toString().substring(0, identifier.indexOf('<'));
    }
    visible = (id === '2');
    return visible;
  }
  public isWorkMinorTerm(model) {
    let isWorkMinorTerm = false;
    isWorkMinorTerm = model?.worksData?.warningEndingWorksTerm && model?.worksData.warningEndingWorksTerm === 1;
    return isWorkMinorTerm;
  }


  //Pestaña observaciones
  public isOpenSimplifiedAbreviated(model: any) {
    let visible = false;
    visible = ProcurementProjectAYMADValidations.isOpenSimplifiedAbreviated(model);
    return visible;
  }
  public isVisibleNoDefinitiveGuarantee(model: any) {
    let visible = false;
    visible = !ProcurementProjectAYMADValidations.isWorks(model);
    return visible;
  }

  public valueNoDefinitiveGuarantee(model: any) {
    let isWorks = ProcurementProjectAYMADValidations.isWorks(model);
    let value = isWorks ? false : model.noDefinitiveGuarantee;
    return value;
  }

  public isVisibleComplementaryGuarantee(model: any) {
    let isWorks = ProcurementProjectAYMADValidations.isWorks(model);
    let isServices = ProcurementProjectAYMADValidations.isServices(model);
    let isGoods = ProcurementProjectAYMADValidations.isGoods(model);
    //let noDefinitiveGuarantee = model?.noDefinitiveGuarantee != null && model.noDefinitiveGuarantee;
    let definitiveGuarantee = model?.definitiveGuarantee != null && model?.definitiveGuarantee;
    let visible = isWorks || ((isServices || isGoods) && definitiveGuarantee);
    return visible;
  }

  public setTextInitiallyTemerityTender(model: any) {
    if (model?.complementaryGuarantee && model?.complementaryGuarantee) {
      model.initiallyTemerityTender = '1% del precio final ofertado por el licitador excluido el Impuesto sobre el Valor Añadido';
    }
  }



  // Funciones II.j////////

  public setTextSubContractTermAuthorized(model: any) {
    if (model.parent?.exp_Subcontratacion_2023) {
      return 'Procede la subcontratación';
    } else {
      return 'Se autoriza la subcontratación';
    }
  }


  /*public valueSubContractTermAuthorized(model: any) {
    let apportioned = model.parent?.breakdownLot?.apportioned;

    if (model.parent.exp_Subcontratacion_2023) {
      return model.subContractTerm.authorized;
    } else {
      if (!apportioned) {
        // Hay que ver si el expediente es reservado de subcontracion
        if (model.parent?.characteristicsContractObject?.isReservedContract &&
          model.parent?.characteristicsContractObject?.reservedContractType != null &&
          model.parent?.characteristicsContractObject?.reservedContractType.properties.SUBCONTRATACION === 1) {
          return true;
        }
        if (model.dataOutsourcing !== null && model.dataOutsourcing) {
          return true;
        }
      }
      return model.subContractTerm.authorized;
    }

  }*/

  public valueSubContractTermAuthorized(model: any) {
    let apportioned = model.parent?.breakdownLot?.apportioned;

    if (model.parent.exp_Subcontratacion_2023) {
      model.subContractTerm.authorized = true;
    } else {
      if (!apportioned) {
        // Hay que ver si el expediente es reservado de subcontracion
        if (model.parent?.characteristicsContractObject?.isReservedContract &&
          model.parent?.characteristicsContractObject?.reservedContractType != null &&
          model.parent?.characteristicsContractObject?.reservedContractType.properties.SUBCONTRATACION === 1) {
          model.subContractTerm.authorized = true;
        }
        if (model.dataOutsourcing !== null && model.dataOutsourcing) {
          model.subContractTerm.authorized = true;
        }
      }
      return model.subContractTerm.authorized;
    }
  }


  public defaulValueSubContractTermAuthorized(model: any) {
    let apportioned = model.parent?.breakdownLot?.apportioned;

    if (model.parent?.exp_Subcontratacion_2023) {
      return true;
    } else {
      if (!apportioned) {
        // Hay que ver si el expediente es reservado de subcontracion
        if (model.parent?.characteristicsContractObject?.isReservedContract &&
          model.parent?.characteristicsContractObject?.reservedContractType != null &&
          model.parent?.characteristicsContractObject?.reservedContractType.properties.SUBCONTRATACION === 1) {
          return true;
        }
      }
      if (model.dataOutsourcing !== null && model.dataOutsourcing) {
        return true;
      }
    }
    return model.subContractTerm.authorized;
  }

  public editableSubContractTermAuthorized(model: any) {
    let apportioned = model.parent?.breakdownLot?.apportioned;
    let isSubcontract = false;

    if (apportioned) {//Si tiene lotes, se mira el tipo de contrato reservado
      let isSubContractReserved = false;
      isSubContractReserved = model.extLotReservedContractType && model.extLotReservedContractType.properties
        && model.extLotReservedContractType.properties.SUBCONTRATACION === 1
      // En el caso de que el lote sea reservado de subcontratacion
      if ((model.extLotIsReservedContract && model.extLotReservedContractType != null && isSubContractReserved)) {
        isSubcontract = true;
      }

    } else {
      // SI NO tiene lotes Hay que ver si el expediente es reservado de subcontracion
      if (model.parent?.characteristicsContractObject?.isReservedContract
        && model.parent?.characteristicsContractObject?.reservedContractType != null
        && model.parent?.characteristicsContractObject?.reservedContractType.properties.SUBCONTRATACION === 1) {
        isSubcontract = true;
      }
    }

    // No es editable y se precarga por defecto con valor 1
    if (model.dataOutsourcing !== null && model.dataOutsourcing) {
      return false;
    }

    if (isSubcontract) {
      return false;
    }
    return true;
  }

  public valueServicesTendererOblig(model: any) {
    let result = false;

    if (model.parent.exp_Rdl_14_2019 && model.subContractTerm?.authorized &&
      model.dataOutsourcing !== undefined && model.dataOutsourcing != null && model.dataOutsourcing) {
      return result = true;
    }
    return undefined;
  }

  public visibilityServicesTendererOblig(model: any) {
    if (model.parent.exp_Rdl_14_2019 && model.subContractTerm?.authorized && model.dataOutsourcing !== undefined
      && model.dataOutsourcing != null && model.dataOutsourcing) {
      return true;
    }
    return false;
  }

  public valueObligationSubcontract(model: any) {

    let apportioned = model.parent?.breakdownLot?.apportioned;

    if (model.subContractTerm?.authorized) {
      if (!model.parent.exp_Rdl_14_2019) {
        //if (!model.parent.exp_Instruccion_1_2019) {
        // Si esta desglosado en lotes
        if (apportioned) {
          let isSubContractReserved = false;
          isSubContractReserved = model.extLotReservedContractType && model.extLotReservedContractType.properties
            && model.extLotReservedContractType.properties.SUBCONTRATACION === 1
          // En el caso de que el lote sea reservado de subcontratacion o si el resto de lotes al menos uno de ellos es reservado de subcontratacion
          if ((model.extLotIsReservedContract && model.extLotReservedContractType != null && isSubContractReserved)) {
            return true;
          }

        } else {
          // SINO esta desglosado en lotes, Hay que ver si el expediente es reservado de subcontracion //// POR AQUI VOY
          if (model.parent?.characteristicsContractObject?.isReservedContract
            && model.parent?.characteristicsContractObject?.reservedContractType != null
            && model.parent?.characteristicsContractObject?.reservedContractType.properties.SUBCONTRATACION === 1) {
            return true;
          }
        }
      }
    } else {
      return undefined;
    }

    return model.subContractTerm.obligationSubcontract;

  }

  public editableObligationSubcontract(model: any) {
    let apportioned = model.parent?.breakdownLot?.apportioned;
    let editable = true;

    if (model.subContractTerm?.authorized) {
      if (!model.parent.exp_Rdl_14_2019) {
        //if (!model.parent.exp_Instruccion_1_2019) {
        // Si esta desglosado en lotes
        if (apportioned) {
          let isSubContractReserved = false;
          isSubContractReserved = model.extLotReservedContractType && model.extLotReservedContractType.properties.SUBCONTRATACION === 1
          // En el caso de que el lote sea reservado de subcontratacion o si el resto de lotes al menos uno de ellos es reservado de subcontratacion
          if (model.extLotIsReservedContract && model.extLotReservedContractType != null && isSubContractReserved) {
            editable = false;

          }

        } else {
          // SINO esta desglosado en lotes, Hay que ver si el expediente es reservado de subcontracion //
          if (model.parent?.characteristicsContractObject?.isReservedContract && model.parent?.characteristicsContractObject?.reservedContractType != null && model.parent?.characteristicsContractObject?.reservedContractType.properties.SUBCONTRATACION === 1) {
            editable = false;
          }
        }
      }
    } else {
      editable = false;
    }

    return editable;

  }

  public visiblePercentageSubcontracted(model: any) {
    // Porcentaje de subcontratación a favor de Empresas de InserciónSocial/ Centros Especiales de Empleo
    if (model.subContractTerm?.authorized && model.parent?.breakdownLot?.apportioned !== undefined &&
      !model.parent?.breakdownLot?.apportioned) {
      if ((model.parent?.exp_Rdl_14_2019 || model.parent?.exp_Instruccion_1_2022) && !model.parent.exp_Subcontratacion_2023) {
        //if ((model.parent?.exp_Instruccion_1_2019 || model.parent?.exp_Instruccion_1_2022) && !model.parent.exp_Subcontratacion_2023) {
        if (model.parent?.characteristicsContractObject?.isReservedContract &&
          model.parent?.characteristicsContractObject?.reservedContractType != null
          && model.parent?.characteristicsContractObject?.reservedContractType.properties.SUBCONTRATACION === 1) {
          return true;
        }
      }
    }
    return false;

  }

  public visibleReservedPercentageSubcontracted(model: any) {
    // Porcentaje de subcontratación a favor de Empresas de InserciónSocial/ Centros Especiales de Empleo
    if (model.subContractTerm?.authorized && model.parent?.breakdownLot?.apportioned !== undefined &&
      model.parent?.breakdownLot?.apportioned) {
      if (!model.parent?.exp_Instruccion_1_2022 && !model.parent.exp_Subcontratacion_2023) {
        if (model.parent?.characteristicsContractObject?.isReservedContract &&
          model.parent?.characteristicsContractObject?.reservedContractType != null
          && model.parent?.characteristicsContractObject?.reservedContractType.properties.SUBCONTRATACION === 1) {
          return true;
        }
      }
    }
    return false;

  }

  public editableExtLotReservedPercentageSubcontracted(model: any) {
    let apportioned = model.parent?.breakdownLot?.apportioned;
    let isSubContractReserved = false;

    if (apportioned && model.subContractTerm?.authorized) {
      isSubContractReserved = model.extLotReservedContractType && model.extLotReservedContractType.properties &&
        model.extLotReservedContractType.properties.SUBCONTRATACION === 1;
    }
    return isSubContractReserved;
  }

  public visibleCriteriaTechnicalFinancialGroup(model: any) {
    let openSimplifiedAbreviated =
      model.parent.type &&
      model.parent.type.identifier !== undefined &&
      model.parent.type.identifier === 'ASA<>PROCEDIMIENTOSCONTRA';

    let lotSolvencyAccreditationActive = model.lotSolvencyAccreditation !== undefined
      && model.lotSolvencyAccreditation != null && model.lotSolvencyAccreditation;

    // El del lote en su momento  o en del expediente
    let estimatedAmount =
      (model?.budget?.estimatedAmount === undefined || model?.budget?.estimatedAmount == null)
        ? 0
        : model.budget.estimatedAmount;
    let limitAmount = model?.auxProperties !== undefined && model?.auxProperties['LIMITE_VE_FE'] !== undefined ?
      parseFloat(model?.auxProperties['LIMITE_VE_FE']) : 0;

    let visibilityByAmount = false;

    // Si está desglosado en lotes
    /*if (model.lotId !== 0) {
      let estimatedAmountFE = 0;
      let estimatedAmountPrevious = 0;
      if (model.budget.estimatedAmountPrevious) {
        estimatedAmountPrevious = model.budget.estimatedAmountPrevious
      }
      // visibilityByAmount = estimatedAmount <= limitAmount
      // Valor estimado de la FE
      estimatedAmountFE = model?.parent?.budget?.estimatedAmount;

      if (estimatedAmountPrevious !== estimatedAmount) {
        estimatedAmountFE = estimatedAmountFE - estimatedAmountPrevious + estimatedAmount;
      }

      if (estimatedAmountFE <= limitAmount && estimatedAmount <= limitAmount) {
        visibilityByAmount = true;
      }

    } else {
      visibilityByAmount = estimatedAmount <= limitAmount
    }*/

    visibilityByAmount = estimatedAmount <= limitAmount;

    let visible = (!openSimplifiedAbreviated && visibilityByAmount && (lotSolvencyAccreditationActive)) ||
      (!openSimplifiedAbreviated && !visibilityByAmount);

    return visible;


  }



  public isVisibleSelectionCriteriaContent(model: any) {
    return ProcurementProjectAYMADValidations.isOpenContract(model) || ProcurementProjectAYMADValidations.isRestrictedContract(model) ||
      ProcurementProjectAYMADValidations.isNegotiated(model);
  }

  public isVisibleSocClausesSocialPerspective(model: any) {


    let visible = false;

    if (model.parent?.classification?.awardMethod?.identifier !== 'P<>FORMASADJUDICACION') {
      return false;
    }

    if ((model.socClausesAwardCriteria != null && !model.socClausesAwardCriteria) || (model.socClausesAwardCriteria === undefined || model.socClausesAwardCriteria === null)) {
      return false;
    }

    let fechaInicioValidezPS = null;
    let fechaFinValidezPS = null;

    let dateFormat = 'dd/MM/yyyy';
    let dateLocale = 'es-ES';

    let fechaIniPS = model?.auxProperties !== undefined && model?.auxProperties['FECHA_INIVALIDEZ_PS'] != undefined ? model?.auxProperties['FECHA_INIVALIDEZ_PS'] : null;
    let fechaFinPS = model?.auxProperties !== undefined && model?.auxProperties['FECHA_FINVALIDEZ_PS'] != undefined ? model?.auxProperties['FECHA_FINVALIDEZ_PS'] : null;

    if (fechaIniPS != null) {
      fechaInicioValidezPS = formatDate(moment(fechaIniPS.replace(/-/g, '/'), dateFormat.toUpperCase()).toDate(), dateFormat, dateLocale);
    }
    if (fechaFinPS != null) {
      fechaFinValidezPS = formatDate(moment(fechaFinPS.replace(/-/g, '/'), dateFormat.toUpperCase()).toDate(), dateFormat, dateLocale);
    }

    let date_Expte_Instruc_1_16 = model?.auxProperties !== undefined && model?.auxProperties['EXPTE_FECHA_PARA_INSTRUC_1_16'] !== undefined ?
      model?.auxProperties['EXPTE_FECHA_PARA_INSTRUC_1_16'] : null;

    if (fechaInicioValidezPS != null && fechaFinValidezPS != null && date_Expte_Instruc_1_16 != null) {
      if ((date_Expte_Instruc_1_16 > fechaInicioValidezPS || date_Expte_Instruc_1_16 === fechaInicioValidezPS)
        && ((date_Expte_Instruc_1_16 < fechaFinValidezPS) || date_Expte_Instruc_1_16 === fechaFinValidezPS)) {
        visible = true;
      }
    }

    return visible;

  }

  public setTextPanelIIa(model: any) {
    let text = 'II.A) LOTES';
    if (model.loteId === 0) {
      text = 'II.A) CESIÓN Y TRATAMIENTO DE DATOS';
    }
    return text;
  }

  public visibleHarmonizedRegulation(model: any) {
    let isServices = false;
    if (model.classification && model.classification.typeCode) {
      isServices = (model.classification.typeCode === undefined || model.classification.typeCode === null)
        ? false
        : model.classification.typeCode.identifier === '04<>TIPOEXPTE';
    }

    let isSimplifiedOpen = false;
    if (model.type) {
      isSimplifiedOpen = model.type.identifier === 'AS<>PROCEDIMIENTOSCONTRA';
    }

    let isOpenSimplifiedAbreviated = false;
    if (model.type) {
      isOpenSimplifiedAbreviated = model.type.identifier === 'ASA<>PROCEDIMIENTOSCONTRA';
    }
    if (isServices && (!isSimplifiedOpen && !isOpenSimplifiedAbreviated)) {
      return true;
    }

    return false;

  }


  // FIN FUNCIONES - FICHA EXPTE DOS PASOS //






  // FIN DE FUNCIONES, FE CONTRATACION

  registerFunctions(frmConfig: FormConfig): void {
    // FUNCIONES PARA FICHA EXPEDIENTE MENOR //

    frmConfig.functions.push({
      identifier: 'enabledBudgetTotalTaxes',
      fn: this.enabledBudgetTotalTaxes
    });

    // FIN DE FUNCIONES PARA EL MENOR //

    // FUNCIONES PARA FICHAEXPEDIENTE DOS PASOS//
    frmConfig.functions.push({
      identifier: 'isVisibleProcurementCommittee',
      fn: this.isVisibleProcurementCommittee
    });

    frmConfig.functions.push({
      identifier: 'visibleHarmonizedRegulation',
      fn: this.visibleHarmonizedRegulation
    });

    // NO SE USA, DE MOMENTO
    frmConfig.functions.push({
      identifier: 'isEnabledProcurementCommittee',
      fn: this.isEnabledProcurementCommittee
    });
    // NO SE USA, DE MOMENTO
    frmConfig.functions.push({
      identifier: 'valueProcurementCommittee',
      fn: this.valueProcurementCommittee
    });

    frmConfig.functions.push({
      identifier: 'valueFinancingSuspCond',
      fn: this.valueFinancingSuspCond
    });
    frmConfig.functions.push({
      identifier: 'enabledFinancingSuspCond',
      fn: this.enabledFinancingSuspCond
    });
    frmConfig.functions.push({
      identifier: 'enabledExpenseCode',
      fn: this.enabledExpenseCode
    });
    frmConfig.functions.push({
      identifier: 'valueChangeExpenseCode',
      fn: this.valueChangeExpenseCode
    });

    frmConfig.functions.push({
      identifier: 'isVisibleLotsPanel',
      fn: this.isVisibleLotsPanel
    });

    frmConfig.functions.push({
      identifier: 'isSimplifiedOpen',
      fn: this.isSimplifiedOpen
    });

    frmConfig.functions.push({
      identifier: 'isUniquePriceCriteria',
      fn: this.isUniquePriceCriteria
    });
    frmConfig.functions.push({
      identifier: 'valueAwardMethod',
      fn: this.valueAwardMethod
    });
    frmConfig.functions.push({
      identifier: 'isVisibleSubTypeCode',
      fn: this.isVisibleSubTypeCode
    });
    frmConfig.functions.push({
      identifier: 'visibleMainContractNumber',
      fn: this.visibleMainContractNumber
    });

    frmConfig.functions.push({
      identifier: 'valueConfidentialityPeriod',
      fn: this.valueConfidentialityPeriod
    });

    // FUNCIONES QUE SE UTILIZA DESDE EL PASO2
    frmConfig.functions.push({
      identifier: 'visibleScheduledSubrogationLot',
      fn: this.visibleScheduledSubrogationLot
    });
    frmConfig.functions.push({
      identifier: 'visibleSubrogationUnfulfillment',
      fn: this.visibleSubrogationUnfulfillment
    });
    frmConfig.functions.push({
      identifier: 'setValueSubrogationUnfulfillment',
      fn: this.setValueSubrogationUnfulfillment
    });
    frmConfig.functions.push({
      identifier: 'setValueScheduledSubrogation',
      fn: this.setValueScheduledSubrogation
    });
    frmConfig.functions.push({
      identifier: 'editablecheduledSubrogation',
      fn: this.editablecheduledSubrogation
    });

    frmConfig.functions.push({
      identifier: 'isApportioned',
      fn: this.isApportioned
    });
    frmConfig.functions.push({
      identifier: 'isExp_Rdl_14_2019',
      fn: this.isExp_Rdl_14_2019
    });
    frmConfig.functions.push({
      identifier: 'isVisibleBudgetDeterminationSystem',
      fn: this.isVisibleBudgetDeterminationSystem
    });
    frmConfig.functions.push({
      identifier: 'valueBudgetTypeLot',
      fn: this.valueBudgetTypeLot
    });
    frmConfig.functions.push({
      identifier: 'enabledBudgetManualCalculationLot',
      fn: this.enabledBudgetManualCalculationLot
    });
    frmConfig.functions.push({
      identifier: 'visibleCanonAmountLot',
      fn: this.visibleCanonAmountLot
    });
    frmConfig.functions.push({
      identifier: 'visiblePriceIncreaseLot',
      fn: this.visiblePriceIncreaseLot
    });
    frmConfig.functions.push({
      identifier: 'visiblePriceDeterminationLot',
      fn: this.visiblePriceDeterminationLot
    });

    frmConfig.functions.push({
      identifier: 'visibleOthersCriteriaTechnicalFinancialLot',
      fn: this.visibleOthersCriteriaTechnicalFinancialLot
    });
    frmConfig.functions.push({
      identifier: 'valueTotalAmount_UnitPrice',
      fn: this.valueTotalAmount_UnitPrice
    });
    frmConfig.functions.push({
      identifier: 'editableFileds_UnitPrice',
      fn: this.editableFileds_UnitPrice
    });
    frmConfig.functions.push({
      identifier: 'isVisibleClassificationCompany',
      fn: this.isVisibleClassificationCompany
    });

    frmConfig.functions.push({
      identifier: 'isVisibleAwardCriteriaLot',
      fn: this.isVisibleAwardCriteriaLot
    });

    frmConfig.functions.push({
      identifier: 'setTextObjectiveCriteriaDesc',
      fn: this.setTextObjectiveCriteriaDesc
    });

    frmConfig.functions.push({
      identifier: 'setTextExistSubjectiveCriteria',
      fn: this.setTextExistSubjectiveCriteria
    });

    frmConfig.functions.push({
      identifier: 'getValueNIDLowerTender',
      fn: this.getValueNIDLowerTender
    });



    frmConfig.functions.push({
      identifier: 'isVisibleSelectionCriteriaLot',
      fn: this.isVisibleSelectionCriteriaLot
    });

    frmConfig.functions.push({
      identifier: 'valueProvisionalGuaranteePercentage',
      fn: this.valueProvisionalGuaranteePercentage
    });

    frmConfig.functions.push({
      identifier: 'valueProvisionalGuarantee',
      fn: this.valueProvisionalGuarantee
    });

    frmConfig.functions.push({
      identifier: 'noVisibleOffersContent',
      fn: this.noVisibleOffersContent
    });

    frmConfig.functions.push({
      identifier: 'setTextotherDocsEnvelope2',
      fn: this.setTextotherDocsEnvelope2
    });
    frmConfig.functions.push({
      identifier: 'visibleOtherDocsEnvelope2',
      fn: this.visibleOtherDocsEnvelope2
    });
    frmConfig.functions.push({
      identifier: 'visibleOtherDocsEnvelope3',
      fn: this.visibleOtherDocsEnvelope3
    });
    frmConfig.functions.push({
      identifier: 'visibleAdmVarPro',
      fn: this.visibleAdmVarPro
    });
    frmConfig.functions.push({
      identifier: 'visibleQuantCritEnvelope',
      fn: this.visibleQuantCritEnvelope
    });
    frmConfig.functions.push({
      identifier: 'isVisibleCompanyToInvite',
      fn: this.isVisibleCompanyToInvite
    });
    frmConfig.functions.push({
      identifier: 'isVisibleWorkProgram',
      fn: this.isVisibleWorkProgram
    });
    /*frmConfig.functions.push({
      identifier: 'isVisiblePriceRevisionWorks',
      fn: this.isVisiblePriceRevisionWorks
    });*/

    frmConfig.functions.push({
      identifier: 'isVisiblePriceRevision',
      fn: this.isVisiblePriceRevision
    });

    frmConfig.functions.push({
      identifier: 'isVisiblePriceRevisionFormula',
      fn: this.isVisiblePriceRevisionFormula
    });

    frmConfig.functions.push({
      identifier: 'isVisibleMethod',
      fn: this.isVisibleMethod
    });
    // Pestaña II.j
    frmConfig.functions.push({
      identifier: 'setTextSubContractTermAuthorized',
      fn: this.setTextSubContractTermAuthorized
    });
    frmConfig.functions.push({
      identifier: 'valueSubContractTermAuthorized',
      fn: this.valueSubContractTermAuthorized
    });
    frmConfig.functions.push({
      identifier: 'defaulValueSubContractTermAuthorized',
      fn: this.defaulValueSubContractTermAuthorized
    });

    frmConfig.functions.push({
      identifier: 'editableSubContractTermAuthorized',
      fn: this.editableSubContractTermAuthorized
    });
    frmConfig.functions.push({
      identifier: 'valueObligationSubcontract',
      fn: this.valueObligationSubcontract
    });

    frmConfig.functions.push({
      identifier: 'editableObligationSubcontract',
      fn: this.editableObligationSubcontract
    });
    frmConfig.functions.push({
      identifier: 'editableExtLotReservedPercentageSubcontracted',
      fn: this.editableExtLotReservedPercentageSubcontracted
    });
    frmConfig.functions.push({
      identifier: 'visibleReservedPercentageSubcontracted',
      fn: this.visibleReservedPercentageSubcontracted
    });

    frmConfig.functions.push({
      identifier: 'visiblePercentageSubcontracted',
      fn: this.visiblePercentageSubcontracted
    });
    frmConfig.functions.push({
      identifier: 'valueServicesTendererOblig',
      fn: this.valueServicesTendererOblig
    });
    frmConfig.functions.push({
      identifier: 'visibilityServicesTendererOblig',
      fn: this.visibilityServicesTendererOblig
    });
    //Pestaña II.k
    frmConfig.functions.push({
      identifier: 'isVisibleAwardCriteriaUnfulfillment',
      fn: this.isVisibleAwardCriteriaUnfulfillment
    });
    //Pestaña II.l - vero
    frmConfig.functions.push({
      identifier: 'isVisibleDataWorks',
      fn: this.isVisibleDataWorks
    });
    frmConfig.functions.push({
      identifier: 'visibleTrialPercentaje',
      fn: this.visibleTrialPercentaje
    });
    frmConfig.functions.push({
      identifier: 'isWorkMinorTerm',
      fn: this.isWorkMinorTerm
    });
    //Pestaña observaciones
    frmConfig.functions.push({
      identifier: 'isOpenSimplifiedAbreviated',
      fn: this.isOpenSimplifiedAbreviated
    });
    frmConfig.functions.push({
      identifier: 'isVisibleNoDefinitiveGuarantee',
      fn: this.isVisibleNoDefinitiveGuarantee
    });
    frmConfig.functions.push({
      identifier: 'valueNoDefinitiveGuarantee',
      fn: this.valueNoDefinitiveGuarantee
    });
    frmConfig.functions.push({
      identifier: 'isVisibleComplementaryGuarantee',
      fn: this.isVisibleComplementaryGuarantee
    });
    frmConfig.functions.push({
      identifier: 'setTextInitiallyTemerityTender',
      fn: this.setTextInitiallyTemerityTender
    });




    // FIN FUNCIONES QUE SE UTILIZAN DESDE EL PASO 2
    // FIN FUNCIONES FE DOS PASOS//

    /// FIN DE FUNCIONES DE AYUMAD


    frmConfig.functions.push({
      identifier: 'isVisibleSelectionCriteriaAward',
      fn: this.isVisibleSelectionCriteriaAward
    });

    frmConfig.functions.push({
      identifier: 'isVisibleSelectionCriteria',
      fn: this.isVisibleSelectionCriteria
    });


    frmConfig.functions.push({
      identifier: 'isvisibleComplementarySystem',
      fn: this.isvisibleComplementarySystem
    });

    frmConfig.functions.push({
      identifier: 'isVisibleSpecialEconomicTerm',
      fn: this.isVisibleSpecialEconomicTerm
    });
    frmConfig.functions.push({
      identifier: 'isVisibleNoticeDocumentReference',
      fn: this.isVisibleNoticeDocumentReference
    });

    frmConfig.functions.push({
      identifier: 'isVisibleCompanyToInviteCBAM',
      fn: this.isVisibleCompanyToInviteCBAM
    });
    frmConfig.functions.push({
      identifier: 'clearFromControlCompanyToInvite',
      fn: this.clearFromControlCompanyToInvite
    });
    frmConfig.functions.push({
      identifier: 'isBasedFrameworkAgreement',
      fn: this.isBasedFrameworkAgreement
    });
    frmConfig.functions.push({
      identifier: 'isVisibleCriteriaTechnicalFinancial',
      fn: this.isVisibleCriteriaTechnicalFinancial
    });

    frmConfig.functions.push({
      identifier: 'isVisibleSubcontractTerm',
      fn: this.isVisibleSubcontractTerm
    });
    frmConfig.functions.push({
      identifier: 'isVisibleContractExtension',
      fn: this.isVisibleContractExtension
    });
    frmConfig.functions.push({
      identifier: 'valueFinalFinancialGuaranteePercentage',
      fn: this.valueFinalFinancialGuaranteePercentage
    });

    frmConfig.functions.push({
      identifier: 'isVisiblePenaltyClauses',
      fn: this.isVisiblePenaltyClauses
    });
    frmConfig.functions.push({
      identifier: 'isVisibleLowTendersDescription',
      fn: this.isVisibleLowTendersDescription
    });
    frmConfig.functions.push({
      identifier: 'isVisibleFichCriteriaTechnicalFinancial',
      fn: this.isVisibleFichCriteriaTechnicalFinancial
    });
    frmConfig.functions.push({
      identifier: 'isVisibleCategory',
      fn: this.isVisibleCategory
    });
    frmConfig.functions.push({
      identifier: 'isVisiblePrice',
      fn: this.isVisiblePrice
    });
    frmConfig.functions.push({
      identifier: 'isVisiblePriceRevision',
      fn: this.isVisiblePriceRevision
    });


    /*frmConfig.functions.push({
      identifier: 'isVisiblePriceRevisionNotWorks',
      fn: this.isVisiblePriceRevisionNotWorks
    });*/

    frmConfig.functions.push({
      identifier: 'valueBudgetAmountExcludingTaxes',
      fn: this.valueBudgetAmountExcludingTaxes
    });
    frmConfig.functions.push({
      identifier: 'enabledAmountExcludingTaxes',
      fn: this.enabledAmountExcludingTaxes
    });
    frmConfig.functions.push({
      identifier: 'valueBudgetTaxType',
      fn: this.valueBudgetTaxType
    });
    frmConfig.functions.push({
      identifier: 'enabledBudgetTaxType',
      fn: this.enabledBudgetTaxType
    });
    frmConfig.functions.push({
      identifier: 'isVisibleBudgetAccountLine',
      fn: this.isVisibleBudgetAccountLine
    });
    frmConfig.functions.push({
      identifier: 'enabledCofinancing',
      fn: this.enabledCofinancing
    });
    frmConfig.functions.push({
      identifier: 'isVisibleCofinancing',
      fn: this.isVisibleCofinancing
    });
    frmConfig.functions.push({
      identifier: 'enabledTaxRate',
      fn: this.enabledTaxRate
    });
    frmConfig.functions.push({
      identifier: 'valueTaxRate',
      fn: this.valueTaxRate
    });
    frmConfig.functions.push({
      identifier: 'isVisibleFrameworkAgreementCriteria',
      fn: this.isVisibleFrameworkAgreementCriteria
    });
    frmConfig.functions.push({
      identifier: 'isVisibleHeaderBudgetBreakdown',
      fn: this.isVisibleHeaderBudgetBreakdown
    });
    frmConfig.functions.push({
      identifier: 'isVisibleprovisionalGuarantee',
      fn: this.isVisibleprovisionalGuarantee
    });
    frmConfig.functions.push({
      identifier: 'visibleFrameworkAgreementCriteria',
      fn: this.visibleFrameworkAgreementCriteria
    });
    frmConfig.functions.push({
      identifier: 'isVisibleCriteriaConcretion',
      fn: this.isVisibleCriteriaConcretion
    });
    frmConfig.functions.push({
      identifier: 'isVisibleBaseContractNoRelated',
      fn: this.isVisibleBaseContractNoRelated
    });
    frmConfig.functions.push({
      identifier: 'isEnabledFrameworkAgreementCriteria',
      fn: this.isEnabledFrameworkAgreementCriteria
    });

    frmConfig.functions.push({
      identifier: 'isActiveBaseContractRelated',
      fn: this.isActiveBaseContractRelated
    });
    frmConfig.functions.push({
      identifier: 'visibleRequestedMaterial_CBAM_CSDA',
      fn: this.visibleRequestedMaterial_CBAM_CSDA
    });
    frmConfig.functions.push({
      identifier: 'editableNumLicitableLots',
      fn: this.editableNumLicitableLots
    });
    frmConfig.functions.push({
      identifier: 'isCatalogProcurementProject',
      fn: this.isCatalogProcurementProject
    });
    frmConfig.functions.push({
      identifier: 'isApplicableLegislationLCSP_RDL_3_20',
      fn: ProcurementProjectAYMADValidations.isApplicableLegislationLCSP_RDL_3_20
    });
    frmConfig.functions.push({
      identifier: 'isVisibleNoticeDocumentReferenceRDL_3_20',
      fn: this.isVisibleNoticeDocumentReferenceRDL_3_20
    });
    frmConfig.functions.push({
      identifier: 'isVisiblePenaltyClausesOther',
      fn: this.isVisiblePenaltyClausesOther
    });
    frmConfig.functions.push({
      identifier: 'isVisibleSocClausesSocialPerspective',
      fn: this.isVisibleSocClausesSocialPerspective
    });
    frmConfig.functions.push({
      identifier: 'setTextPanelIIa',
      fn: this.setTextPanelIIa
    });
    // FUNCIONES ASOCIADAS A LOS MODOS --------------------------------
    frmConfig.functions.push({
      identifier: 'isMinorContractMode',
      fn: this.isMinorContractMode
    });
    frmConfig.functions.push({
      identifier: 'isOpenContractMode',
      fn: this.isOpenContractMode
    });
    frmConfig.functions.push({
      identifier: 'isNegotiatedMode',
      fn: this.isNegotiatedMode
    });
    frmConfig.functions.push({
      identifier: 'isRestrictedMode',
      fn: this.isRestrictedMode
    });
    frmConfig.functions.push({
      identifier: 'isBasedFrameworkAgreementMode',
      fn: this.isBasedFrameworkAgreementMode
    });
    frmConfig.functions.push({
      identifier: 'isCompetitiveDialogueMode',
      fn: this.isCompetitiveDialogueMode
    });
    frmConfig.functions.push({
      identifier: 'isCentralizedPurchases',
      fn: this.isCentralizedPurchases
    });
    frmConfig.functions.push({
      identifier: 'updateBudgetData',
      fn: this.updateBudgetData.bind(this)
    });
    frmConfig.functions.push({
      identifier: 'updateTotalAmount',
      fn: this.updateTotalAmount.bind(this)
    });
    frmConfig.functions.push({
      identifier: 'visibleCriteriaTechnicalFinancialGroup',
      fn: this.visibleCriteriaTechnicalFinancialGroup.bind(this)
    });
    frmConfig.functions.push({
      identifier: 'isVisibleSelectionCriteriaContent',
      fn: this.isVisibleSelectionCriteriaContent.bind(this)
    });

    //exp_11_2023
    frmConfig.functions.push({
      identifier: 'isVisiblePriceRevision',
      fn: this.isVisiblePriceRevision
    });



    //visibilidad Tipos de Licitacion Menores
    frmConfig.functions.push({
      identifier: 'isVisibleDirectAwardType',
      fn: this.isVisibleDirectAwardType
    });
    // FIN FUNCIONES ASOCIADAS A LOS MODOS -----------------



  }
}
